// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type {
  FormFilter,
  FormFilterName,
  FormFilterOption,
  FormFilterPriority,
  FormFilterType,
  ContentMetadata_ACTIONABLE,
  ContentMetadataCommon,
  Language,
  ContentId_ACTIONABLE,
  Tag,
  TagSourceType,
  TagKindDynamicString,
  KindDynamicString,
  TagKindDynamicBoolean,
  KindDynamicBoolean,
  TagKindDynamicNumber,
  KindDynamicNumber,
  TagKindDynamicVoid,
  KindDynamicVoid,
  TagKindChannel,
  KindChannel,
  TagKindPrimarySkill,
  KindPrimarySkill,
  TagKindSkill,
  KindSkill,
  TagKindKeyQuality,
  KindKeyQuality,
  TagKindClassification,
  KindClassification,
  PageInfo,
  ContentMetadata_MIAB,
  ContentId_MIAB,
  ContentMetadata_SUMMARY,
  AuthorListView,
  Gender,
  ContentId_SUMMARY,
  ContentItemType,
  Country,
  SummaryDocumentType,
  SummarySourceType,
  FormSorting,
  FormSortingOption,
  ContentMetadataView,
} from "../schema";

export function serialize_ContentMetadataView(obj: ContentMetadataView): string {
  const serialized = ((value: {
    actionable: {
      filter: FormFilter[];
      items: ContentMetadata_ACTIONABLE[];
      pageInfo: PageInfo;
    };
    miab: {
      filter: FormFilter[];
      items: ContentMetadata_MIAB[];
      pageInfo: PageInfo;
    };
    summary: {
      filter: FormFilter[];
      items: ContentMetadata_SUMMARY[];
      pageInfo: PageInfo;
      sorting: FormSorting;
    };
  }): unknown => {
    return {
      actionable: ((value: { filter: FormFilter[]; items: ContentMetadata_ACTIONABLE[]; pageInfo: PageInfo }): unknown => {
        return {
          filter: ((value: FormFilter[]): unknown => {
            return value.map((value: { activeValues: string[]; identifier: FormFilterName; label: string; name: string; options: FormFilterOption[]; priority: FormFilterPriority; type: FormFilterType }): unknown => {
              return {
                activeValues: ((value: string[]): unknown => {
                  return value.map((value: string): unknown => {
                    return value;
                  });
                })(value["activeValues"]),
                identifier: ((value: "CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"): unknown => {
                  return value;
                })(value["identifier"]),
                label: ((value: string): unknown => {
                  return value;
                })(value["label"]),
                name: ((value: string): unknown => {
                  return value;
                })(value["name"]),
                options: ((value: FormFilterOption[]): unknown => {
                  return value.map((value: { label: string; shortLabel: string | null; value: string }): unknown => {
                    return {
                      label: ((value: string): unknown => {
                        return value;
                      })(value["label"]),
                      shortLabel: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["shortLabel"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  });
                })(value["options"]),
                priority: ((value: "PRIMARY" | "SECONDARY"): unknown => {
                  return value;
                })(value["priority"]),
                type: ((value: "MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"): unknown => {
                  return value;
                })(value["type"]),
              };
            });
          })(value["filter"]),
          items: ((value: ContentMetadata_ACTIONABLE[]): unknown => {
            return value.map(
              (value: {
                actionableId: bigint;
                activatedAt: DateTime<true> | null;
                active: boolean;
                common: ContentMetadataCommon;
                contentId: ContentId_ACTIONABLE;
                contentType: "ACTIONABLE";
                coverUri: string;
                description: string;
                language: Language;
                modifiedAt: DateTime<true>;
                name: string;
                tags: Tag[];
                title: string;
              }): unknown => {
                return {
                  actionableId: ((value: bigint): unknown => {
                    return value;
                  })(value["actionableId"]),
                  activatedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["activatedAt"]),
                  active: ((value: boolean): unknown => {
                    return value;
                  })(value["active"]),
                  common: ((value: {
                    activatedAt: DateTime<true> | null;
                    audioActive: boolean;
                    coverUri: string;
                    description: string | null;
                    inactive: boolean;
                    language: Language;
                    leadIn: string | null;
                    link: string | null;
                    title: string;
                  }): unknown => {
                    return {
                      activatedAt: ((value: DateTime<true> | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value.toMillis();
                      })(value["activatedAt"]),
                      audioActive: ((value: boolean): unknown => {
                        return value;
                      })(value["audioActive"]),
                      coverUri: ((value: string): unknown => {
                        return value;
                      })(value["coverUri"]),
                      description: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["description"]),
                      inactive: ((value: boolean): unknown => {
                        return value;
                      })(value["inactive"]),
                      language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                        return value;
                      })(value["language"]),
                      leadIn: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["leadIn"]),
                      link: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["link"]),
                      title: ((value: string): unknown => {
                        return value;
                      })(value["title"]),
                    };
                  })(value["common"]),
                  contentId: ((value: { contentType: "ACTIONABLE"; id: bigint }): unknown => {
                    return {
                      contentType: ((value: "ACTIONABLE"): unknown => {
                        return value;
                      })(value["contentType"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                    };
                  })(value["contentId"]),
                  contentType: ((value: "ACTIONABLE"): unknown => {
                    return value;
                  })(value["contentType"]),
                  coverUri: ((value: string): unknown => {
                    return value;
                  })(value["coverUri"]),
                  description: ((value: string): unknown => {
                    return value;
                  })(value["description"]),
                  language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                    return value;
                  })(value["language"]),
                  modifiedAt: ((value: DateTime<true>): unknown => {
                    return value.toMillis();
                  })(value["modifiedAt"]),
                  name: ((value: string): unknown => {
                    return value;
                  })(value["name"]),
                  tags: ((value: Tag[]): unknown => {
                    return value.map(
                      (
                        value:
                          | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                          | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                          | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                          | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                          | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                          | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                          | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                          | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                          | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string },
                      ): unknown => {
                        switch (value.discriminator) {
                          case "dynamicString": {
                            return {
                              discriminator: "dynamicString",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicString; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicString"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicBoolean": {
                            return {
                              discriminator: "dynamicBoolean",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicBoolean; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicBoolean"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: boolean): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicNumber": {
                            return {
                              discriminator: "dynamicNumber",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicNumber; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicNumber"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: number): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicVoid": {
                            return {
                              discriminator: "dynamicVoid",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicVoid; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicVoid"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                            };
                          }
                          case "channel": {
                            return {
                              discriminator: "channel",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindChannel; id: bigint; kind: KindChannel }): unknown => {
                                return {
                                  discriminator: ((value: "channel"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "channel"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "primary-skill": {
                            return {
                              discriminator: "primary-skill",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindPrimarySkill; id: bigint; kind: KindPrimarySkill }): unknown => {
                                return {
                                  discriminator: ((value: "primary-skill"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "primary-skill"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "skill": {
                            return {
                              discriminator: "skill",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindSkill; id: bigint; kind: KindSkill }): unknown => {
                                return {
                                  discriminator: ((value: "skill"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "skill"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "key-quality": {
                            return {
                              discriminator: "key-quality",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindKeyQuality; id: bigint; kind: KindKeyQuality }): unknown => {
                                return {
                                  discriminator: ((value: "key-quality"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "key-quality"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "classification": {
                            return {
                              discriminator: "classification",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindClassification; id: bigint; kind: KindClassification }): unknown => {
                                return {
                                  discriminator: ((value: "classification"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "classification"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                        }
                      },
                    );
                  })(value["tags"]),
                  title: ((value: string): unknown => {
                    return value;
                  })(value["title"]),
                };
              },
            );
          })(value["items"]),
          pageInfo: ((value: { page: number; pageSize: number; totalCount: number }): unknown => {
            return {
              page: ((value: number): unknown => {
                return value;
              })(value["page"]),
              pageSize: ((value: number): unknown => {
                return value;
              })(value["pageSize"]),
              totalCount: ((value: number): unknown => {
                return value;
              })(value["totalCount"]),
            };
          })(value["pageInfo"]),
        };
      })(value["actionable"]),
      miab: ((value: { filter: FormFilter[]; items: ContentMetadata_MIAB[]; pageInfo: PageInfo }): unknown => {
        return {
          filter: ((value: FormFilter[]): unknown => {
            return value.map((value: { activeValues: string[]; identifier: FormFilterName; label: string; name: string; options: FormFilterOption[]; priority: FormFilterPriority; type: FormFilterType }): unknown => {
              return {
                activeValues: ((value: string[]): unknown => {
                  return value.map((value: string): unknown => {
                    return value;
                  });
                })(value["activeValues"]),
                identifier: ((value: "CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"): unknown => {
                  return value;
                })(value["identifier"]),
                label: ((value: string): unknown => {
                  return value;
                })(value["label"]),
                name: ((value: string): unknown => {
                  return value;
                })(value["name"]),
                options: ((value: FormFilterOption[]): unknown => {
                  return value.map((value: { label: string; shortLabel: string | null; value: string }): unknown => {
                    return {
                      label: ((value: string): unknown => {
                        return value;
                      })(value["label"]),
                      shortLabel: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["shortLabel"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  });
                })(value["options"]),
                priority: ((value: "PRIMARY" | "SECONDARY"): unknown => {
                  return value;
                })(value["priority"]),
                type: ((value: "MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"): unknown => {
                  return value;
                })(value["type"]),
              };
            });
          })(value["filter"]),
          items: ((value: ContentMetadata_MIAB[]): unknown => {
            return value.map((value: { common: ContentMetadataCommon; contentId: ContentId_MIAB; contentType: "MIAB"; customerId: number | null; dataId: number }): unknown => {
              return {
                common: ((value: {
                  activatedAt: DateTime<true> | null;
                  audioActive: boolean;
                  coverUri: string;
                  description: string | null;
                  inactive: boolean;
                  language: Language;
                  leadIn: string | null;
                  link: string | null;
                  title: string;
                }): unknown => {
                  return {
                    activatedAt: ((value: DateTime<true> | null): unknown => {
                      if (value === null) {
                        return null;
                      }
                      return value.toMillis();
                    })(value["activatedAt"]),
                    audioActive: ((value: boolean): unknown => {
                      return value;
                    })(value["audioActive"]),
                    coverUri: ((value: string): unknown => {
                      return value;
                    })(value["coverUri"]),
                    description: ((value: string | null): unknown => {
                      if (value === null) {
                        return null;
                      }
                      return value;
                    })(value["description"]),
                    inactive: ((value: boolean): unknown => {
                      return value;
                    })(value["inactive"]),
                    language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                      return value;
                    })(value["language"]),
                    leadIn: ((value: string | null): unknown => {
                      if (value === null) {
                        return null;
                      }
                      return value;
                    })(value["leadIn"]),
                    link: ((value: string | null): unknown => {
                      if (value === null) {
                        return null;
                      }
                      return value;
                    })(value["link"]),
                    title: ((value: string): unknown => {
                      return value;
                    })(value["title"]),
                  };
                })(value["common"]),
                contentId: ((value: { contentType: "MIAB"; id: bigint }): unknown => {
                  return {
                    contentType: ((value: "MIAB"): unknown => {
                      return value;
                    })(value["contentType"]),
                    id: ((value: bigint): unknown => {
                      return value;
                    })(value["id"]),
                  };
                })(value["contentId"]),
                contentType: ((value: "MIAB"): unknown => {
                  return value;
                })(value["contentType"]),
                customerId: ((value: number | null): unknown => {
                  if (value === null) {
                    return null;
                  }
                  return value;
                })(value["customerId"]),
                dataId: ((value: number): unknown => {
                  return value;
                })(value["dataId"]),
              };
            });
          })(value["items"]),
          pageInfo: ((value: { page: number; pageSize: number; totalCount: number }): unknown => {
            return {
              page: ((value: number): unknown => {
                return value;
              })(value["page"]),
              pageSize: ((value: number): unknown => {
                return value;
              })(value["pageSize"]),
              totalCount: ((value: number): unknown => {
                return value;
              })(value["totalCount"]),
            };
          })(value["pageInfo"]),
        };
      })(value["miab"]),
      summary: ((value: { filter: FormFilter[]; items: ContentMetadata_SUMMARY[]; pageInfo: PageInfo; sorting: FormSorting }): unknown => {
        return {
          filter: ((value: FormFilter[]): unknown => {
            return value.map((value: { activeValues: string[]; identifier: FormFilterName; label: string; name: string; options: FormFilterOption[]; priority: FormFilterPriority; type: FormFilterType }): unknown => {
              return {
                activeValues: ((value: string[]): unknown => {
                  return value.map((value: string): unknown => {
                    return value;
                  });
                })(value["activeValues"]),
                identifier: ((value: "CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"): unknown => {
                  return value;
                })(value["identifier"]),
                label: ((value: string): unknown => {
                  return value;
                })(value["label"]),
                name: ((value: string): unknown => {
                  return value;
                })(value["name"]),
                options: ((value: FormFilterOption[]): unknown => {
                  return value.map((value: { label: string; shortLabel: string | null; value: string }): unknown => {
                    return {
                      label: ((value: string): unknown => {
                        return value;
                      })(value["label"]),
                      shortLabel: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["shortLabel"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  });
                })(value["options"]),
                priority: ((value: "PRIMARY" | "SECONDARY"): unknown => {
                  return value;
                })(value["priority"]),
                type: ((value: "MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"): unknown => {
                  return value;
                })(value["type"]),
              };
            });
          })(value["filter"]),
          items: ((value: ContentMetadata_SUMMARY[]): unknown => {
            return value.map(
              (value: {
                activatedAt: DateTime<true> | null;
                activationTime: DateTime<true> | null;
                active: boolean;
                audioActivatedAt: DateTime<true> | null;
                audioActive: boolean;
                audioDuration: number;
                authorInfo: string | null;
                authors: AuthorListView[];
                backgroundColor: string | null;
                bestseller: boolean;
                businessClassic: boolean;
                canonicalName: string;
                common: ContentMetadataCommon;
                contentId: ContentId_SUMMARY;
                contentItemId: bigint;
                contentItemType: ContentItemType;
                contentType: "SUMMARY";
                countriesExcluded: Country[];
                countriesIncluded: Country[];
                coverModifiedAt: DateTime<true> | null;
                coverUri: string;
                dataId: number;
                descriptionHtml: string | null;
                documentType: SummaryDocumentType;
                duration: number;
                imageBorder: boolean;
                language: Language;
                miabId: bigint | null;
                modifiedAt: DateTime<true> | null;
                originalTitle: string | null;
                previewAvailable: boolean;
                publicationDate: string | null;
                publisherInfo: string | null;
                publisherName: string | null;
                rating: number | null;
                sourceType: SummarySourceType;
                subtitle: string | null;
                summaryPages: number;
                summaryWords: number;
                tags: Tag[];
                teaser: string | null;
                title: string | null;
              }): unknown => {
                return {
                  activatedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["activatedAt"]),
                  activationTime: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["activationTime"]),
                  active: ((value: boolean): unknown => {
                    return value;
                  })(value["active"]),
                  audioActivatedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["audioActivatedAt"]),
                  audioActive: ((value: boolean): unknown => {
                    return value;
                  })(value["audioActive"]),
                  audioDuration: ((value: number): unknown => {
                    return value;
                  })(value["audioDuration"]),
                  authorInfo: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["authorInfo"]),
                  authors: ((value: AuthorListView[]): unknown => {
                    return value.map((value: { authorId: number; firstName: string | null; gender: Gender | null; lastName: string | null; middleName: string | null }): unknown => {
                      return {
                        authorId: ((value: number): unknown => {
                          return value;
                        })(value["authorId"]),
                        firstName: ((value: string | null): unknown => {
                          if (value === null) {
                            return null;
                          }
                          return value;
                        })(value["firstName"]),
                        gender: ((value: ("FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM") | null): unknown => {
                          if (value === null) {
                            return null;
                          }
                          return value;
                        })(value["gender"]),
                        lastName: ((value: string | null): unknown => {
                          if (value === null) {
                            return null;
                          }
                          return value;
                        })(value["lastName"]),
                        middleName: ((value: string | null): unknown => {
                          if (value === null) {
                            return null;
                          }
                          return value;
                        })(value["middleName"]),
                      };
                    });
                  })(value["authors"]),
                  backgroundColor: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["backgroundColor"]),
                  bestseller: ((value: boolean): unknown => {
                    return value;
                  })(value["bestseller"]),
                  businessClassic: ((value: boolean): unknown => {
                    return value;
                  })(value["businessClassic"]),
                  canonicalName: ((value: string): unknown => {
                    return value;
                  })(value["canonicalName"]),
                  common: ((value: {
                    activatedAt: DateTime<true> | null;
                    audioActive: boolean;
                    coverUri: string;
                    description: string | null;
                    inactive: boolean;
                    language: Language;
                    leadIn: string | null;
                    link: string | null;
                    title: string;
                  }): unknown => {
                    return {
                      activatedAt: ((value: DateTime<true> | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value.toMillis();
                      })(value["activatedAt"]),
                      audioActive: ((value: boolean): unknown => {
                        return value;
                      })(value["audioActive"]),
                      coverUri: ((value: string): unknown => {
                        return value;
                      })(value["coverUri"]),
                      description: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["description"]),
                      inactive: ((value: boolean): unknown => {
                        return value;
                      })(value["inactive"]),
                      language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                        return value;
                      })(value["language"]),
                      leadIn: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["leadIn"]),
                      link: ((value: string | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["link"]),
                      title: ((value: string): unknown => {
                        return value;
                      })(value["title"]),
                    };
                  })(value["common"]),
                  contentId: ((value: { contentType: "SUMMARY"; id: bigint }): unknown => {
                    return {
                      contentType: ((value: "SUMMARY"): unknown => {
                        return value;
                      })(value["contentType"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                    };
                  })(value["contentId"]),
                  contentItemId: ((value: bigint): unknown => {
                    return value;
                  })(value["contentItemId"]),
                  contentItemType: ((value: "UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "LGXP" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY"): unknown => {
                    return value;
                  })(value["contentItemType"]),
                  contentType: ((value: "SUMMARY"): unknown => {
                    return value;
                  })(value["contentType"]),
                  countriesExcluded: ((value: Country[]): unknown => {
                    return value.map(
                      (value: {
                        countryCode: string;
                        currency: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY";
                        names: {
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        };
                        phonePrefix: string;
                        region: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA";
                      }): unknown => {
                        return {
                          countryCode: ((value: string): unknown => {
                            return value;
                          })(value["countryCode"]),
                          currency: ((value: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"): unknown => {
                            return value;
                          })(value["currency"]),
                          names: ((value: { de: string; en: string; es: string; fr: string; pt: string; ru: string; zh: string }): unknown => {
                            return {
                              de: ((value: string): unknown => {
                                return value;
                              })(value["de"]),
                              en: ((value: string): unknown => {
                                return value;
                              })(value["en"]),
                              es: ((value: string): unknown => {
                                return value;
                              })(value["es"]),
                              fr: ((value: string): unknown => {
                                return value;
                              })(value["fr"]),
                              pt: ((value: string): unknown => {
                                return value;
                              })(value["pt"]),
                              ru: ((value: string): unknown => {
                                return value;
                              })(value["ru"]),
                              zh: ((value: string): unknown => {
                                return value;
                              })(value["zh"]),
                            };
                          })(value["names"]),
                          phonePrefix: ((value: string): unknown => {
                            return value;
                          })(value["phonePrefix"]),
                          region: ((value: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"): unknown => {
                            return value;
                          })(value["region"]),
                        };
                      },
                    );
                  })(value["countriesExcluded"]),
                  countriesIncluded: ((value: Country[]): unknown => {
                    return value.map(
                      (value: {
                        countryCode: string;
                        currency: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY";
                        names: {
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        };
                        phonePrefix: string;
                        region: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA";
                      }): unknown => {
                        return {
                          countryCode: ((value: string): unknown => {
                            return value;
                          })(value["countryCode"]),
                          currency: ((value: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"): unknown => {
                            return value;
                          })(value["currency"]),
                          names: ((value: { de: string; en: string; es: string; fr: string; pt: string; ru: string; zh: string }): unknown => {
                            return {
                              de: ((value: string): unknown => {
                                return value;
                              })(value["de"]),
                              en: ((value: string): unknown => {
                                return value;
                              })(value["en"]),
                              es: ((value: string): unknown => {
                                return value;
                              })(value["es"]),
                              fr: ((value: string): unknown => {
                                return value;
                              })(value["fr"]),
                              pt: ((value: string): unknown => {
                                return value;
                              })(value["pt"]),
                              ru: ((value: string): unknown => {
                                return value;
                              })(value["ru"]),
                              zh: ((value: string): unknown => {
                                return value;
                              })(value["zh"]),
                            };
                          })(value["names"]),
                          phonePrefix: ((value: string): unknown => {
                            return value;
                          })(value["phonePrefix"]),
                          region: ((value: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"): unknown => {
                            return value;
                          })(value["region"]),
                        };
                      },
                    );
                  })(value["countriesIncluded"]),
                  coverModifiedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["coverModifiedAt"]),
                  coverUri: ((value: string): unknown => {
                    return value;
                  })(value["coverUri"]),
                  dataId: ((value: number): unknown => {
                    return value;
                  })(value["dataId"]),
                  descriptionHtml: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["descriptionHtml"]),
                  documentType: ((value: "ABSTRACT" | "REVIEW"): unknown => {
                    return value;
                  })(value["documentType"]),
                  duration: ((value: number): unknown => {
                    return value;
                  })(value["duration"]),
                  imageBorder: ((value: boolean): unknown => {
                    return value;
                  })(value["imageBorder"]),
                  language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                    return value;
                  })(value["language"]),
                  miabId: ((value: bigint | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["miabId"]),
                  modifiedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["modifiedAt"]),
                  originalTitle: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["originalTitle"]),
                  previewAvailable: ((value: boolean): unknown => {
                    return value;
                  })(value["previewAvailable"]),
                  publicationDate: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["publicationDate"]),
                  publisherInfo: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["publisherInfo"]),
                  publisherName: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["publisherName"]),
                  rating: ((value: number | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["rating"]),
                  sourceType: ((value: "BOOK" | "VIDEO" | "ARTICLE" | "CHAPTER" | "REPORT" | "PODCAST"): unknown => {
                    return value;
                  })(value["sourceType"]),
                  subtitle: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["subtitle"]),
                  summaryPages: ((value: number): unknown => {
                    return value;
                  })(value["summaryPages"]),
                  summaryWords: ((value: number): unknown => {
                    return value;
                  })(value["summaryWords"]),
                  tags: ((value: Tag[]): unknown => {
                    return value.map(
                      (
                        value:
                          | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                          | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                          | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                          | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                          | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                          | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                          | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                          | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                          | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string },
                      ): unknown => {
                        switch (value.discriminator) {
                          case "dynamicString": {
                            return {
                              discriminator: "dynamicString",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicString; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicString"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicBoolean": {
                            return {
                              discriminator: "dynamicBoolean",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicBoolean; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicBoolean"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: boolean): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicNumber": {
                            return {
                              discriminator: "dynamicNumber",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicNumber; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicNumber"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: number): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "dynamicVoid": {
                            return {
                              discriminator: "dynamicVoid",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindDynamicVoid; id: bigint; kind: string }): unknown => {
                                return {
                                  discriminator: ((value: "dynamicVoid"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: string): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                            };
                          }
                          case "channel": {
                            return {
                              discriminator: "channel",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindChannel; id: bigint; kind: KindChannel }): unknown => {
                                return {
                                  discriminator: ((value: "channel"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "channel"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "primary-skill": {
                            return {
                              discriminator: "primary-skill",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindPrimarySkill; id: bigint; kind: KindPrimarySkill }): unknown => {
                                return {
                                  discriminator: ((value: "primary-skill"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "primary-skill"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "skill": {
                            return {
                              discriminator: "skill",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindSkill; id: bigint; kind: KindSkill }): unknown => {
                                return {
                                  discriminator: ((value: "skill"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "skill"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "key-quality": {
                            return {
                              discriminator: "key-quality",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindKeyQuality; id: bigint; kind: KindKeyQuality }): unknown => {
                                return {
                                  discriminator: ((value: "key-quality"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "key-quality"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                          case "classification": {
                            return {
                              discriminator: "classification",
                              exclude: ((value: boolean): unknown => {
                                return value;
                              })(value["exclude"]),
                              score: ((value: number): unknown => {
                                return value;
                              })(value["score"]),
                              source: ((value: "USER" | "AI"): unknown => {
                                return value;
                              })(value["source"]),
                              tagKind: ((value: { discriminator: KindClassification; id: bigint; kind: KindClassification }): unknown => {
                                return {
                                  discriminator: ((value: "classification"): unknown => {
                                    return value;
                                  })(value["discriminator"]),
                                  id: ((value: bigint): unknown => {
                                    return value;
                                  })(value["id"]),
                                  kind: ((value: "classification"): unknown => {
                                    return value;
                                  })(value["kind"]),
                                };
                              })(value["tagKind"]),
                              value: ((value: string): unknown => {
                                return value;
                              })(value["value"]),
                            };
                          }
                        }
                      },
                    );
                  })(value["tags"]),
                  teaser: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["teaser"]),
                  title: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["title"]),
                };
              },
            );
          })(value["items"]),
          pageInfo: ((value: { page: number; pageSize: number; totalCount: number }): unknown => {
            return {
              page: ((value: number): unknown => {
                return value;
              })(value["page"]),
              pageSize: ((value: number): unknown => {
                return value;
              })(value["pageSize"]),
              totalCount: ((value: number): unknown => {
                return value;
              })(value["totalCount"]),
            };
          })(value["pageInfo"]),
          sorting: ((value: { activeValue: string; options: FormSortingOption[] }): unknown => {
            return {
              activeValue: ((value: string): unknown => {
                return value;
              })(value["activeValue"]),
              options: ((value: FormSortingOption[]): unknown => {
                return value.map((value: { label: string; value: string }): unknown => {
                  return {
                    label: ((value: string): unknown => {
                      return value;
                    })(value["label"]),
                    value: ((value: string): unknown => {
                      return value;
                    })(value["value"]),
                  };
                });
              })(value["options"]),
            };
          })(value["sorting"]),
        };
      })(value["summary"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ContentMetadataView(str: string): ParserResult<ContentMetadataView> {
  return ((
    value: unknown,
  ): ParserResult<{
    actionable: {
      filter: FormFilter[];
      items: ContentMetadata_ACTIONABLE[];
      pageInfo: PageInfo;
    };
    miab: {
      filter: FormFilter[];
      items: ContentMetadata_MIAB[];
      pageInfo: PageInfo;
    };
    summary: {
      filter: FormFilter[];
      items: ContentMetadata_SUMMARY[];
      pageInfo: PageInfo;
      sorting: FormSorting;
    };
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ContentMetadataView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ContentMetadataView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "actionable")) {
      return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionable'.` };
    }
    const parsed_actionable = ((): ParserResult<{
      filter: FormFilter[];
      items: ContentMetadata_ACTIONABLE[];
      pageInfo: PageInfo;
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        filter: FormFilter[];
        items: ContentMetadata_ACTIONABLE[];
        pageInfo: PageInfo;
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "filter")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable/filter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'filter'.` };
        }
        const parsed_filter = ((): ParserResult<FormFilter[]> => {
          return ((value: unknown): ParserResult<FormFilter[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable/filter]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<FormFilter> => {
              return ((
                value: unknown,
              ): ParserResult<{
                activeValues: string[];
                identifier: FormFilterName;
                label: string;
                name: string;
                options: FormFilterOption[];
                priority: FormFilterPriority;
                type: FormFilterType;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "activeValues")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activeValues'.` };
                }
                const parsed_activeValues = ((): ParserResult<string[]> => {
                  return ((value: unknown): ParserResult<string[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/activeValues]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["activeValues"]);
                })();
                if (!parsed_activeValues.success) {
                  return { success: false, reason: parsed_activeValues.reason };
                }
                if (!hasProp(value, "identifier")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/identifier]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'identifier'.` };
                }
                const parsed_identifier = ((): ParserResult<FormFilterName> => {
                  return ((value: unknown): ParserResult<FormFilterName> => {
                    return ((value: unknown): ParserResult<"CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "CHANNEL":
                          return { success: true, value: "CHANNEL" };
                        case "SOURCE":
                          return { success: true, value: "SOURCE" };
                        case "QUALITY":
                          return { success: true, value: "QUALITY" };
                        case "RATING":
                          return { success: true, value: "RATING" };
                        case "AUDIO":
                          return { success: true, value: "AUDIO" };
                        case "LANGUAGE":
                          return { success: true, value: "LANGUAGE" };
                        case "PUBLICATION_DATE":
                          return { success: true, value: "PUBLICATION_DATE" };
                        case "MIAB":
                          return { success: true, value: "MIAB" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be enum, one of 'CHANNEL, SOURCE, QUALITY, RATING, AUDIO, LANGUAGE, PUBLICATION_DATE, MIAB'.` };
                      }
                    })(value);
                  })(value["identifier"]);
                })();
                if (!parsed_identifier.success) {
                  return { success: false, reason: parsed_identifier.reason };
                }
                if (!hasProp(value, "label")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                }
                const parsed_label = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["label"]);
                })();
                if (!parsed_label.success) {
                  return { success: false, reason: parsed_label.reason };
                }
                if (!hasProp(value, "name")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                }
                const parsed_name = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["name"]);
                })();
                if (!parsed_name.success) {
                  return { success: false, reason: parsed_name.reason };
                }
                if (!hasProp(value, "options")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'options'.` };
                }
                const parsed_options = ((): ParserResult<FormFilterOption[]> => {
                  return ((value: unknown): ParserResult<FormFilterOption[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<FormFilterOption> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        label: string;
                        shortLabel: string | null;
                        value: string;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "label")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                        }
                        const parsed_label = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["label"]);
                        })();
                        if (!parsed_label.success) {
                          return { success: false, reason: parsed_label.reason };
                        }
                        if (!hasProp(value, "shortLabel")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shortLabel'.` };
                        }
                        const parsed_shortLabel = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["shortLabel"]);
                        })();
                        if (!parsed_shortLabel.success) {
                          return { success: false, reason: parsed_shortLabel.reason };
                        }
                        if (!hasProp(value, "value")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                        }
                        const parsed_value = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["value"]);
                        })();
                        if (!parsed_value.success) {
                          return { success: false, reason: parsed_value.reason };
                        }
                        return { success: true, value: { label: parsed_label.value, shortLabel: parsed_shortLabel.value, value: parsed_value.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/options]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["options"]);
                })();
                if (!parsed_options.success) {
                  return { success: false, reason: parsed_options.reason };
                }
                if (!hasProp(value, "priority")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/priority]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'priority'.` };
                }
                const parsed_priority = ((): ParserResult<FormFilterPriority> => {
                  return ((value: unknown): ParserResult<FormFilterPriority> => {
                    return ((value: unknown): ParserResult<"PRIMARY" | "SECONDARY"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "PRIMARY":
                          return { success: true, value: "PRIMARY" };
                        case "SECONDARY":
                          return { success: true, value: "SECONDARY" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be enum, one of 'PRIMARY, SECONDARY'.` };
                      }
                    })(value);
                  })(value["priority"]);
                })();
                if (!parsed_priority.success) {
                  return { success: false, reason: parsed_priority.reason };
                }
                if (!hasProp(value, "type")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
                }
                const parsed_type = ((): ParserResult<FormFilterType> => {
                  return ((value: unknown): ParserResult<FormFilterType> => {
                    return ((value: unknown): ParserResult<"MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "MULTICHECKBOX":
                          return { success: true, value: "MULTICHECKBOX" };
                        case "CHECKBOX":
                          return { success: true, value: "CHECKBOX" };
                        case "MULTISELECT":
                          return { success: true, value: "MULTISELECT" };
                        case "RANGE":
                          return { success: true, value: "RANGE" };
                        case "RANGE_MIN":
                          return { success: true, value: "RANGE_MIN" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be enum, one of 'MULTICHECKBOX, CHECKBOX, MULTISELECT, RANGE, RANGE_MIN'.` };
                      }
                    })(value);
                  })(value["type"]);
                })();
                if (!parsed_type.success) {
                  return { success: false, reason: parsed_type.reason };
                }
                return {
                  success: true,
                  value: {
                    activeValues: parsed_activeValues.value,
                    identifier: parsed_identifier.value,
                    label: parsed_label.value,
                    name: parsed_name.value,
                    options: parsed_options.value,
                    priority: parsed_priority.value,
                    type: parsed_type.value,
                  },
                };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/actionable/filter]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["filter"]);
        })();
        if (!parsed_filter.success) {
          return { success: false, reason: parsed_filter.reason };
        }
        if (!hasProp(value, "items")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
        }
        const parsed_items = ((): ParserResult<ContentMetadata_ACTIONABLE[]> => {
          return ((value: unknown): ParserResult<ContentMetadata_ACTIONABLE[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable/items]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<ContentMetadata_ACTIONABLE> => {
              return ((
                value: unknown,
              ): ParserResult<{
                actionableId: bigint;
                activatedAt: DateTime<true> | null;
                active: boolean;
                common: ContentMetadataCommon;
                contentId: ContentId_ACTIONABLE;
                contentType: "ACTIONABLE";
                coverUri: string;
                description: string;
                language: Language;
                modifiedAt: DateTime<true>;
                name: string;
                tags: Tag[];
                title: string;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "actionableId")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/actionableId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionableId'.` };
                }
                const parsed_actionableId = ((): ParserResult<bigint> => {
                  return ((value: unknown): ParserResult<bigint> => {
                    if (typeof value === "number") {
                      return { success: true, value: BigInt(value) };
                    }
                    if (typeof value === "bigint") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/ActionableMetadata/actionableId]: '${value}' expected to be of type bigint or number.` };
                  })(value["actionableId"]);
                })();
                if (!parsed_actionableId.success) {
                  return { success: false, reason: parsed_actionableId.reason };
                }
                if (!hasProp(value, "activatedAt")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
                }
                const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/activatedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/activatedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["activatedAt"]);
                })();
                if (!parsed_activatedAt.success) {
                  return { success: false, reason: parsed_activatedAt.reason };
                }
                if (!hasProp(value, "active")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
                }
                const parsed_active = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/active]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["active"]);
                })();
                if (!parsed_active.success) {
                  return { success: false, reason: parsed_active.reason };
                }
                if (!hasProp(value, "common")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/common]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'common'.` };
                }
                const parsed_common = ((): ParserResult<ContentMetadataCommon> => {
                  return ((value: unknown): ParserResult<ContentMetadataCommon> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      activatedAt: DateTime<true> | null;
                      audioActive: boolean;
                      coverUri: string;
                      description: string | null;
                      inactive: boolean;
                      language: Language;
                      leadIn: string | null;
                      link: string | null;
                      title: string;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "activatedAt")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
                      }
                      const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
                        return ((value: unknown): ParserResult<DateTime<true> | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "number") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be of type number.` };
                          }
                          const parsed = DateTime.fromMillis(value);
                          if (!parsed.isValid) {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be valid DateTime.` };
                          }
                          return { success: true, value: parsed };
                        })(value["activatedAt"]);
                      })();
                      if (!parsed_activatedAt.success) {
                        return { success: false, reason: parsed_activatedAt.reason };
                      }
                      if (!hasProp(value, "audioActive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActive'.` };
                      }
                      const parsed_audioActive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["audioActive"]);
                      })();
                      if (!parsed_audioActive.success) {
                        return { success: false, reason: parsed_audioActive.reason };
                      }
                      if (!hasProp(value, "coverUri")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                      }
                      const parsed_coverUri = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["coverUri"]);
                      })();
                      if (!parsed_coverUri.success) {
                        return { success: false, reason: parsed_coverUri.reason };
                      }
                      if (!hasProp(value, "description")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
                      }
                      const parsed_description = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["description"]);
                      })();
                      if (!parsed_description.success) {
                        return { success: false, reason: parsed_description.reason };
                      }
                      if (!hasProp(value, "inactive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inactive'.` };
                      }
                      const parsed_inactive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["inactive"]);
                      })();
                      if (!parsed_inactive.success) {
                        return { success: false, reason: parsed_inactive.reason };
                      }
                      if (!hasProp(value, "language")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                      }
                      const parsed_language = ((): ParserResult<Language> => {
                        return ((value: unknown): ParserResult<Language> => {
                          return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "en":
                                return { success: true, value: "en" };
                              case "de":
                                return { success: true, value: "de" };
                              case "es":
                                return { success: true, value: "es" };
                              case "ru":
                                return { success: true, value: "ru" };
                              case "zh":
                                return { success: true, value: "zh" };
                              case "pt":
                                return { success: true, value: "pt" };
                              case "fr":
                                return { success: true, value: "fr" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                            }
                          })(value);
                        })(value["language"]);
                      })();
                      if (!parsed_language.success) {
                        return { success: false, reason: parsed_language.reason };
                      }
                      if (!hasProp(value, "leadIn")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'leadIn'.` };
                      }
                      const parsed_leadIn = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["leadIn"]);
                      })();
                      if (!parsed_leadIn.success) {
                        return { success: false, reason: parsed_leadIn.reason };
                      }
                      if (!hasProp(value, "link")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'link'.` };
                      }
                      const parsed_link = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["link"]);
                      })();
                      if (!parsed_link.success) {
                        return { success: false, reason: parsed_link.reason };
                      }
                      if (!hasProp(value, "title")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                      }
                      const parsed_title = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["title"]);
                      })();
                      if (!parsed_title.success) {
                        return { success: false, reason: parsed_title.reason };
                      }
                      return {
                        success: true,
                        value: {
                          activatedAt: parsed_activatedAt.value,
                          audioActive: parsed_audioActive.value,
                          coverUri: parsed_coverUri.value,
                          description: parsed_description.value,
                          inactive: parsed_inactive.value,
                          language: parsed_language.value,
                          leadIn: parsed_leadIn.value,
                          link: parsed_link.value,
                          title: parsed_title.value,
                        },
                      };
                    })(value);
                  })(value["common"]);
                })();
                if (!parsed_common.success) {
                  return { success: false, reason: parsed_common.reason };
                }
                if (!hasProp(value, "contentId")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
                }
                const parsed_contentId = ((): ParserResult<ContentId_ACTIONABLE> => {
                  return ((value: unknown): ParserResult<ContentId_ACTIONABLE> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      contentType: "ACTIONABLE";
                      id: bigint;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ActionableId]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ActionableId]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "contentType")) {
                        return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                      }
                      const parsed_contentType = ((): ParserResult<"ACTIONABLE"> => {
                        return ((value: unknown): ParserResult<"ACTIONABLE"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "ACTIONABLE":
                              return { success: true, value: "ACTIONABLE" };
                            default:
                              return { success: false, reason: `[#/components/schemas/ActionableId/contentType]: '${value}' expected to be enum, one of 'ACTIONABLE'.` };
                          }
                        })(value["contentType"]);
                      })();
                      if (!parsed_contentType.success) {
                        return { success: false, reason: parsed_contentType.reason };
                      }
                      if (!hasProp(value, "id")) {
                        return { success: false, reason: `[#/components/schemas/ActionableId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                      }
                      const parsed_id = ((): ParserResult<bigint> => {
                        return ((value: unknown): ParserResult<bigint> => {
                          if (typeof value === "number") {
                            return { success: true, value: BigInt(value) };
                          }
                          if (typeof value === "bigint") {
                            return { success: true, value: value };
                          }
                          return { success: false, reason: `[#/components/schemas/ActionableId/id]: '${value}' expected to be of type bigint or number.` };
                        })(value["id"]);
                      })();
                      if (!parsed_id.success) {
                        return { success: false, reason: parsed_id.reason };
                      }
                      return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
                    })(value);
                  })(value["contentId"]);
                })();
                if (!parsed_contentId.success) {
                  return { success: false, reason: parsed_contentId.reason };
                }
                if (!hasProp(value, "contentType")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                }
                const parsed_contentType = ((): ParserResult<"ACTIONABLE"> => {
                  return ((value: unknown): ParserResult<"ACTIONABLE"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/contentType]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "ACTIONABLE":
                        return { success: true, value: "ACTIONABLE" };
                      default:
                        return { success: false, reason: `[#/components/schemas/ActionableMetadata/contentType]: '${value}' expected to be enum, one of 'ACTIONABLE'.` };
                    }
                  })(value["contentType"]);
                })();
                if (!parsed_contentType.success) {
                  return { success: false, reason: parsed_contentType.reason };
                }
                if (!hasProp(value, "coverUri")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                }
                const parsed_coverUri = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/coverUri]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["coverUri"]);
                })();
                if (!parsed_coverUri.success) {
                  return { success: false, reason: parsed_coverUri.reason };
                }
                if (!hasProp(value, "description")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
                }
                const parsed_description = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/description]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["description"]);
                })();
                if (!parsed_description.success) {
                  return { success: false, reason: parsed_description.reason };
                }
                if (!hasProp(value, "language")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                }
                const parsed_language = ((): ParserResult<Language> => {
                  return ((value: unknown): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "en":
                          return { success: true, value: "en" };
                        case "de":
                          return { success: true, value: "de" };
                        case "es":
                          return { success: true, value: "es" };
                        case "ru":
                          return { success: true, value: "ru" };
                        case "zh":
                          return { success: true, value: "zh" };
                        case "pt":
                          return { success: true, value: "pt" };
                        case "fr":
                          return { success: true, value: "fr" };
                        default:
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                      }
                    })(value);
                  })(value["language"]);
                })();
                if (!parsed_language.success) {
                  return { success: false, reason: parsed_language.reason };
                }
                if (!hasProp(value, "modifiedAt")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
                }
                const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
                  return ((value: unknown): ParserResult<DateTime<true>> => {
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/modifiedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/modifiedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["modifiedAt"]);
                })();
                if (!parsed_modifiedAt.success) {
                  return { success: false, reason: parsed_modifiedAt.reason };
                }
                if (!hasProp(value, "name")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                }
                const parsed_name = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/name]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["name"]);
                })();
                if (!parsed_name.success) {
                  return { success: false, reason: parsed_name.reason };
                }
                if (!hasProp(value, "tags")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/tags]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tags'.` };
                }
                const parsed_tags = ((): ParserResult<Tag[]> => {
                  return ((value: unknown): ParserResult<Tag[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/tags]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<Tag> => {
                      return ((
                        value: unknown,
                      ): ParserResult<
                        | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                        | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                        | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                        | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                        | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                        | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                        | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                        | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                        | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                      > => {
                        return ((
                          value: unknown,
                        ): ParserResult<
                          | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                          | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                          | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                          | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                          | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                          | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                          | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                          | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                          | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                        > => {
                          if (value == null) {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${value}' expected to be non-null.` };
                          }
                          if (typeof value != "object") {
                            return { success: false, reason: `[#/components/schemas/Tag]: ${value} expected to be of type 'object'.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          if (typeof value["discriminator"] != "string") {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${value["discriminator"]}' expected to be of type 'string'.` };
                          }
                          const discriminator = value["discriminator"];
                          switch (discriminator) {
                            case "dynamicString": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicString;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicString> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicString> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicString;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicString> => {
                                        return ((value: unknown): ParserResult<KindDynamicString> => {
                                          return ((value: unknown): ParserResult<"dynamicString"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicString":
                                                return { success: true, value: "dynamicString" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be enum, one of 'dynamicString'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicString" as const, ...parsedVariant.value } };
                            }
                            case "dynamicBoolean": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicBoolean;
                                value: boolean;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicBoolean> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicBoolean> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicBoolean;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicBoolean> => {
                                        return ((value: unknown): ParserResult<KindDynamicBoolean> => {
                                          return ((value: unknown): ParserResult<"dynamicBoolean"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicBoolean":
                                                return { success: true, value: "dynamicBoolean" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be enum, one of 'dynamicBoolean'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicBoolean" as const, ...parsedVariant.value } };
                            }
                            case "dynamicNumber": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicNumber;
                                value: number;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicNumber> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicNumber> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicNumber;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicNumber> => {
                                        return ((value: unknown): ParserResult<KindDynamicNumber> => {
                                          return ((value: unknown): ParserResult<"dynamicNumber"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicNumber":
                                                return { success: true, value: "dynamicNumber" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be enum, one of 'dynamicNumber'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${value}' expected to be of type number.` };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicNumber" as const, ...parsedVariant.value } };
                            }
                            case "dynamicVoid": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicVoid;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicVoid> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicVoid> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicVoid;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicVoid> => {
                                        return ((value: unknown): ParserResult<KindDynamicVoid> => {
                                          return ((value: unknown): ParserResult<"dynamicVoid"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicVoid":
                                                return { success: true, value: "dynamicVoid" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be enum, one of 'dynamicVoid'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicVoid" as const, ...parsedVariant.value } };
                            }
                            case "channel": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindChannel;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindChannel> => {
                                  return ((value: unknown): ParserResult<TagKindChannel> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindChannel;
                                      id: bigint;
                                      kind: KindChannel;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindChannel> => {
                                        return ((value: unknown): ParserResult<KindChannel> => {
                                          return ((value: unknown): ParserResult<"channel"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "channel":
                                                return { success: true, value: "channel" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindChannel> => {
                                        return ((value: unknown): ParserResult<KindChannel> => {
                                          return ((value: unknown): ParserResult<"channel"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "channel":
                                                return { success: true, value: "channel" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "channel" as const, ...parsedVariant.value } };
                            }
                            case "primary-skill": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindPrimarySkill;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindPrimarySkill> => {
                                  return ((value: unknown): ParserResult<TagKindPrimarySkill> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindPrimarySkill;
                                      id: bigint;
                                      kind: KindPrimarySkill;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindPrimarySkill> => {
                                        return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                          return ((value: unknown): ParserResult<"primary-skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "primary-skill":
                                                return { success: true, value: "primary-skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindPrimarySkill> => {
                                        return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                          return ((value: unknown): ParserResult<"primary-skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "primary-skill":
                                                return { success: true, value: "primary-skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "primary-skill" as const, ...parsedVariant.value } };
                            }
                            case "skill": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindSkill;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindSkill> => {
                                  return ((value: unknown): ParserResult<TagKindSkill> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindSkill;
                                      id: bigint;
                                      kind: KindSkill;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindSkill> => {
                                        return ((value: unknown): ParserResult<KindSkill> => {
                                          return ((value: unknown): ParserResult<"skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "skill":
                                                return { success: true, value: "skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindSkill> => {
                                        return ((value: unknown): ParserResult<KindSkill> => {
                                          return ((value: unknown): ParserResult<"skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "skill":
                                                return { success: true, value: "skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "skill" as const, ...parsedVariant.value } };
                            }
                            case "key-quality": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindKeyQuality;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindKeyQuality> => {
                                  return ((value: unknown): ParserResult<TagKindKeyQuality> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindKeyQuality;
                                      id: bigint;
                                      kind: KindKeyQuality;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindKeyQuality> => {
                                        return ((value: unknown): ParserResult<KindKeyQuality> => {
                                          return ((value: unknown): ParserResult<"key-quality"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "key-quality":
                                                return { success: true, value: "key-quality" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindKeyQuality> => {
                                        return ((value: unknown): ParserResult<KindKeyQuality> => {
                                          return ((value: unknown): ParserResult<"key-quality"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "key-quality":
                                                return { success: true, value: "key-quality" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "key-quality" as const, ...parsedVariant.value } };
                            }
                            case "classification": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindClassification;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindClassification> => {
                                  return ((value: unknown): ParserResult<TagKindClassification> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindClassification;
                                      id: bigint;
                                      kind: KindClassification;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindClassification> => {
                                        return ((value: unknown): ParserResult<KindClassification> => {
                                          return ((value: unknown): ParserResult<"classification"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "classification":
                                                return { success: true, value: "classification" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindClassification> => {
                                        return ((value: unknown): ParserResult<KindClassification> => {
                                          return ((value: unknown): ParserResult<"classification"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "classification":
                                                return { success: true, value: "classification" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "classification" as const, ...parsedVariant.value } };
                            }
                            default:
                              return {
                                success: false,
                                reason: `[#/components/schemas/Tag]: '${discriminator}' expected to be one of 'dynamicString, dynamicBoolean, dynamicNumber, dynamicVoid, channel, primary-skill, skill, key-quality, classification'.`,
                              };
                          }
                        })(value);
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/ActionableMetadata/tags]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["tags"]);
                })();
                if (!parsed_tags.success) {
                  return { success: false, reason: parsed_tags.reason };
                }
                if (!hasProp(value, "title")) {
                  return { success: false, reason: `[#/components/schemas/ActionableMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                }
                const parsed_title = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/ActionableMetadata/title]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["title"]);
                })();
                if (!parsed_title.success) {
                  return { success: false, reason: parsed_title.reason };
                }
                return {
                  success: true,
                  value: {
                    actionableId: parsed_actionableId.value,
                    activatedAt: parsed_activatedAt.value,
                    active: parsed_active.value,
                    common: parsed_common.value,
                    contentId: parsed_contentId.value,
                    contentType: parsed_contentType.value,
                    coverUri: parsed_coverUri.value,
                    description: parsed_description.value,
                    language: parsed_language.value,
                    modifiedAt: parsed_modifiedAt.value,
                    name: parsed_name.value,
                    tags: parsed_tags.value,
                    title: parsed_title.value,
                  },
                };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/actionable/items]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["items"]);
        })();
        if (!parsed_items.success) {
          return { success: false, reason: parsed_items.reason };
        }
        if (!hasProp(value, "pageInfo")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/actionable/pageInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageInfo'.` };
        }
        const parsed_pageInfo = ((): ParserResult<PageInfo> => {
          return ((value: unknown): ParserResult<PageInfo> => {
            return ((
              value: unknown,
            ): ParserResult<{
              page: number;
              pageSize: number;
              totalCount: number;
            }> => {
              if (typeof value !== "object") {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to be of type 'object'.` };
              }
              if (value === null) {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to not be null.` };
              }
              if (!hasProp(value, "page")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'page'.` };
              }
              const parsed_page = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${value}' expected to be of type number.` };
                })(value["page"]);
              })();
              if (!parsed_page.success) {
                return { success: false, reason: parsed_page.reason };
              }
              if (!hasProp(value, "pageSize")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageSize'.` };
              }
              const parsed_pageSize = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${value}' expected to be of type number.` };
                })(value["pageSize"]);
              })();
              if (!parsed_pageSize.success) {
                return { success: false, reason: parsed_pageSize.reason };
              }
              if (!hasProp(value, "totalCount")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'totalCount'.` };
              }
              const parsed_totalCount = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${value}' expected to be of type number.` };
                })(value["totalCount"]);
              })();
              if (!parsed_totalCount.success) {
                return { success: false, reason: parsed_totalCount.reason };
              }
              return { success: true, value: { page: parsed_page.value, pageSize: parsed_pageSize.value, totalCount: parsed_totalCount.value } };
            })(value);
          })(value["pageInfo"]);
        })();
        if (!parsed_pageInfo.success) {
          return { success: false, reason: parsed_pageInfo.reason };
        }
        return { success: true, value: { filter: parsed_filter.value, items: parsed_items.value, pageInfo: parsed_pageInfo.value } };
      })(value["actionable"]);
    })();
    if (!parsed_actionable.success) {
      return { success: false, reason: parsed_actionable.reason };
    }
    if (!hasProp(value, "miab")) {
      return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'miab'.` };
    }
    const parsed_miab = ((): ParserResult<{
      filter: FormFilter[];
      items: ContentMetadata_MIAB[];
      pageInfo: PageInfo;
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        filter: FormFilter[];
        items: ContentMetadata_MIAB[];
        pageInfo: PageInfo;
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "filter")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab/filter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'filter'.` };
        }
        const parsed_filter = ((): ParserResult<FormFilter[]> => {
          return ((value: unknown): ParserResult<FormFilter[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab/filter]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<FormFilter> => {
              return ((
                value: unknown,
              ): ParserResult<{
                activeValues: string[];
                identifier: FormFilterName;
                label: string;
                name: string;
                options: FormFilterOption[];
                priority: FormFilterPriority;
                type: FormFilterType;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "activeValues")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activeValues'.` };
                }
                const parsed_activeValues = ((): ParserResult<string[]> => {
                  return ((value: unknown): ParserResult<string[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/activeValues]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["activeValues"]);
                })();
                if (!parsed_activeValues.success) {
                  return { success: false, reason: parsed_activeValues.reason };
                }
                if (!hasProp(value, "identifier")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/identifier]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'identifier'.` };
                }
                const parsed_identifier = ((): ParserResult<FormFilterName> => {
                  return ((value: unknown): ParserResult<FormFilterName> => {
                    return ((value: unknown): ParserResult<"CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "CHANNEL":
                          return { success: true, value: "CHANNEL" };
                        case "SOURCE":
                          return { success: true, value: "SOURCE" };
                        case "QUALITY":
                          return { success: true, value: "QUALITY" };
                        case "RATING":
                          return { success: true, value: "RATING" };
                        case "AUDIO":
                          return { success: true, value: "AUDIO" };
                        case "LANGUAGE":
                          return { success: true, value: "LANGUAGE" };
                        case "PUBLICATION_DATE":
                          return { success: true, value: "PUBLICATION_DATE" };
                        case "MIAB":
                          return { success: true, value: "MIAB" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be enum, one of 'CHANNEL, SOURCE, QUALITY, RATING, AUDIO, LANGUAGE, PUBLICATION_DATE, MIAB'.` };
                      }
                    })(value);
                  })(value["identifier"]);
                })();
                if (!parsed_identifier.success) {
                  return { success: false, reason: parsed_identifier.reason };
                }
                if (!hasProp(value, "label")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                }
                const parsed_label = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["label"]);
                })();
                if (!parsed_label.success) {
                  return { success: false, reason: parsed_label.reason };
                }
                if (!hasProp(value, "name")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                }
                const parsed_name = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["name"]);
                })();
                if (!parsed_name.success) {
                  return { success: false, reason: parsed_name.reason };
                }
                if (!hasProp(value, "options")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'options'.` };
                }
                const parsed_options = ((): ParserResult<FormFilterOption[]> => {
                  return ((value: unknown): ParserResult<FormFilterOption[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<FormFilterOption> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        label: string;
                        shortLabel: string | null;
                        value: string;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "label")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                        }
                        const parsed_label = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["label"]);
                        })();
                        if (!parsed_label.success) {
                          return { success: false, reason: parsed_label.reason };
                        }
                        if (!hasProp(value, "shortLabel")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shortLabel'.` };
                        }
                        const parsed_shortLabel = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["shortLabel"]);
                        })();
                        if (!parsed_shortLabel.success) {
                          return { success: false, reason: parsed_shortLabel.reason };
                        }
                        if (!hasProp(value, "value")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                        }
                        const parsed_value = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["value"]);
                        })();
                        if (!parsed_value.success) {
                          return { success: false, reason: parsed_value.reason };
                        }
                        return { success: true, value: { label: parsed_label.value, shortLabel: parsed_shortLabel.value, value: parsed_value.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/options]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["options"]);
                })();
                if (!parsed_options.success) {
                  return { success: false, reason: parsed_options.reason };
                }
                if (!hasProp(value, "priority")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/priority]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'priority'.` };
                }
                const parsed_priority = ((): ParserResult<FormFilterPriority> => {
                  return ((value: unknown): ParserResult<FormFilterPriority> => {
                    return ((value: unknown): ParserResult<"PRIMARY" | "SECONDARY"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "PRIMARY":
                          return { success: true, value: "PRIMARY" };
                        case "SECONDARY":
                          return { success: true, value: "SECONDARY" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be enum, one of 'PRIMARY, SECONDARY'.` };
                      }
                    })(value);
                  })(value["priority"]);
                })();
                if (!parsed_priority.success) {
                  return { success: false, reason: parsed_priority.reason };
                }
                if (!hasProp(value, "type")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
                }
                const parsed_type = ((): ParserResult<FormFilterType> => {
                  return ((value: unknown): ParserResult<FormFilterType> => {
                    return ((value: unknown): ParserResult<"MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "MULTICHECKBOX":
                          return { success: true, value: "MULTICHECKBOX" };
                        case "CHECKBOX":
                          return { success: true, value: "CHECKBOX" };
                        case "MULTISELECT":
                          return { success: true, value: "MULTISELECT" };
                        case "RANGE":
                          return { success: true, value: "RANGE" };
                        case "RANGE_MIN":
                          return { success: true, value: "RANGE_MIN" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be enum, one of 'MULTICHECKBOX, CHECKBOX, MULTISELECT, RANGE, RANGE_MIN'.` };
                      }
                    })(value);
                  })(value["type"]);
                })();
                if (!parsed_type.success) {
                  return { success: false, reason: parsed_type.reason };
                }
                return {
                  success: true,
                  value: {
                    activeValues: parsed_activeValues.value,
                    identifier: parsed_identifier.value,
                    label: parsed_label.value,
                    name: parsed_name.value,
                    options: parsed_options.value,
                    priority: parsed_priority.value,
                    type: parsed_type.value,
                  },
                };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/miab/filter]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["filter"]);
        })();
        if (!parsed_filter.success) {
          return { success: false, reason: parsed_filter.reason };
        }
        if (!hasProp(value, "items")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
        }
        const parsed_items = ((): ParserResult<ContentMetadata_MIAB[]> => {
          return ((value: unknown): ParserResult<ContentMetadata_MIAB[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab/items]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<ContentMetadata_MIAB> => {
              return ((
                value: unknown,
              ): ParserResult<{
                common: ContentMetadataCommon;
                contentId: ContentId_MIAB;
                contentType: "MIAB";
                customerId: number | null;
                dataId: number;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "common")) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata/common]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'common'.` };
                }
                const parsed_common = ((): ParserResult<ContentMetadataCommon> => {
                  return ((value: unknown): ParserResult<ContentMetadataCommon> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      activatedAt: DateTime<true> | null;
                      audioActive: boolean;
                      coverUri: string;
                      description: string | null;
                      inactive: boolean;
                      language: Language;
                      leadIn: string | null;
                      link: string | null;
                      title: string;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "activatedAt")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
                      }
                      const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
                        return ((value: unknown): ParserResult<DateTime<true> | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "number") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be of type number.` };
                          }
                          const parsed = DateTime.fromMillis(value);
                          if (!parsed.isValid) {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be valid DateTime.` };
                          }
                          return { success: true, value: parsed };
                        })(value["activatedAt"]);
                      })();
                      if (!parsed_activatedAt.success) {
                        return { success: false, reason: parsed_activatedAt.reason };
                      }
                      if (!hasProp(value, "audioActive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActive'.` };
                      }
                      const parsed_audioActive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["audioActive"]);
                      })();
                      if (!parsed_audioActive.success) {
                        return { success: false, reason: parsed_audioActive.reason };
                      }
                      if (!hasProp(value, "coverUri")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                      }
                      const parsed_coverUri = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["coverUri"]);
                      })();
                      if (!parsed_coverUri.success) {
                        return { success: false, reason: parsed_coverUri.reason };
                      }
                      if (!hasProp(value, "description")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
                      }
                      const parsed_description = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["description"]);
                      })();
                      if (!parsed_description.success) {
                        return { success: false, reason: parsed_description.reason };
                      }
                      if (!hasProp(value, "inactive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inactive'.` };
                      }
                      const parsed_inactive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["inactive"]);
                      })();
                      if (!parsed_inactive.success) {
                        return { success: false, reason: parsed_inactive.reason };
                      }
                      if (!hasProp(value, "language")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                      }
                      const parsed_language = ((): ParserResult<Language> => {
                        return ((value: unknown): ParserResult<Language> => {
                          return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "en":
                                return { success: true, value: "en" };
                              case "de":
                                return { success: true, value: "de" };
                              case "es":
                                return { success: true, value: "es" };
                              case "ru":
                                return { success: true, value: "ru" };
                              case "zh":
                                return { success: true, value: "zh" };
                              case "pt":
                                return { success: true, value: "pt" };
                              case "fr":
                                return { success: true, value: "fr" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                            }
                          })(value);
                        })(value["language"]);
                      })();
                      if (!parsed_language.success) {
                        return { success: false, reason: parsed_language.reason };
                      }
                      if (!hasProp(value, "leadIn")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'leadIn'.` };
                      }
                      const parsed_leadIn = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["leadIn"]);
                      })();
                      if (!parsed_leadIn.success) {
                        return { success: false, reason: parsed_leadIn.reason };
                      }
                      if (!hasProp(value, "link")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'link'.` };
                      }
                      const parsed_link = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["link"]);
                      })();
                      if (!parsed_link.success) {
                        return { success: false, reason: parsed_link.reason };
                      }
                      if (!hasProp(value, "title")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                      }
                      const parsed_title = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["title"]);
                      })();
                      if (!parsed_title.success) {
                        return { success: false, reason: parsed_title.reason };
                      }
                      return {
                        success: true,
                        value: {
                          activatedAt: parsed_activatedAt.value,
                          audioActive: parsed_audioActive.value,
                          coverUri: parsed_coverUri.value,
                          description: parsed_description.value,
                          inactive: parsed_inactive.value,
                          language: parsed_language.value,
                          leadIn: parsed_leadIn.value,
                          link: parsed_link.value,
                          title: parsed_title.value,
                        },
                      };
                    })(value);
                  })(value["common"]);
                })();
                if (!parsed_common.success) {
                  return { success: false, reason: parsed_common.reason };
                }
                if (!hasProp(value, "contentId")) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
                }
                const parsed_contentId = ((): ParserResult<ContentId_MIAB> => {
                  return ((value: unknown): ParserResult<ContentId_MIAB> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      contentType: "MIAB";
                      id: bigint;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/MiabId]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/MiabId]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "contentType")) {
                        return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                      }
                      const parsed_contentType = ((): ParserResult<"MIAB"> => {
                        return ((value: unknown): ParserResult<"MIAB"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "MIAB":
                              return { success: true, value: "MIAB" };
                            default:
                              return { success: false, reason: `[#/components/schemas/MiabId/contentType]: '${value}' expected to be enum, one of 'MIAB'.` };
                          }
                        })(value["contentType"]);
                      })();
                      if (!parsed_contentType.success) {
                        return { success: false, reason: parsed_contentType.reason };
                      }
                      if (!hasProp(value, "id")) {
                        return { success: false, reason: `[#/components/schemas/MiabId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                      }
                      const parsed_id = ((): ParserResult<bigint> => {
                        return ((value: unknown): ParserResult<bigint> => {
                          if (typeof value === "number") {
                            return { success: true, value: BigInt(value) };
                          }
                          if (typeof value === "bigint") {
                            return { success: true, value: value };
                          }
                          return { success: false, reason: `[#/components/schemas/MiabId/id]: '${value}' expected to be of type bigint or number.` };
                        })(value["id"]);
                      })();
                      if (!parsed_id.success) {
                        return { success: false, reason: parsed_id.reason };
                      }
                      return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
                    })(value);
                  })(value["contentId"]);
                })();
                if (!parsed_contentId.success) {
                  return { success: false, reason: parsed_contentId.reason };
                }
                if (!hasProp(value, "contentType")) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                }
                const parsed_contentType = ((): ParserResult<"MIAB"> => {
                  return ((value: unknown): ParserResult<"MIAB"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/MiabMetadata/contentType]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "MIAB":
                        return { success: true, value: "MIAB" };
                      default:
                        return { success: false, reason: `[#/components/schemas/MiabMetadata/contentType]: '${value}' expected to be enum, one of 'MIAB'.` };
                    }
                  })(value["contentType"]);
                })();
                if (!parsed_contentType.success) {
                  return { success: false, reason: parsed_contentType.reason };
                }
                if (!hasProp(value, "customerId")) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
                }
                const parsed_customerId = ((): ParserResult<number | null> => {
                  return ((value: unknown): ParserResult<number | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/MiabMetadata/customerId]: '${value}' expected to be of type number.` };
                  })(value["customerId"]);
                })();
                if (!parsed_customerId.success) {
                  return { success: false, reason: parsed_customerId.reason };
                }
                if (!hasProp(value, "dataId")) {
                  return { success: false, reason: `[#/components/schemas/MiabMetadata/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
                }
                const parsed_dataId = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/MiabMetadata/dataId]: '${value}' expected to be of type number.` };
                  })(value["dataId"]);
                })();
                if (!parsed_dataId.success) {
                  return { success: false, reason: parsed_dataId.reason };
                }
                return { success: true, value: { common: parsed_common.value, contentId: parsed_contentId.value, contentType: parsed_contentType.value, customerId: parsed_customerId.value, dataId: parsed_dataId.value } };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/miab/items]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["items"]);
        })();
        if (!parsed_items.success) {
          return { success: false, reason: parsed_items.reason };
        }
        if (!hasProp(value, "pageInfo")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/miab/pageInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageInfo'.` };
        }
        const parsed_pageInfo = ((): ParserResult<PageInfo> => {
          return ((value: unknown): ParserResult<PageInfo> => {
            return ((
              value: unknown,
            ): ParserResult<{
              page: number;
              pageSize: number;
              totalCount: number;
            }> => {
              if (typeof value !== "object") {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to be of type 'object'.` };
              }
              if (value === null) {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to not be null.` };
              }
              if (!hasProp(value, "page")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'page'.` };
              }
              const parsed_page = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${value}' expected to be of type number.` };
                })(value["page"]);
              })();
              if (!parsed_page.success) {
                return { success: false, reason: parsed_page.reason };
              }
              if (!hasProp(value, "pageSize")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageSize'.` };
              }
              const parsed_pageSize = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${value}' expected to be of type number.` };
                })(value["pageSize"]);
              })();
              if (!parsed_pageSize.success) {
                return { success: false, reason: parsed_pageSize.reason };
              }
              if (!hasProp(value, "totalCount")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'totalCount'.` };
              }
              const parsed_totalCount = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${value}' expected to be of type number.` };
                })(value["totalCount"]);
              })();
              if (!parsed_totalCount.success) {
                return { success: false, reason: parsed_totalCount.reason };
              }
              return { success: true, value: { page: parsed_page.value, pageSize: parsed_pageSize.value, totalCount: parsed_totalCount.value } };
            })(value);
          })(value["pageInfo"]);
        })();
        if (!parsed_pageInfo.success) {
          return { success: false, reason: parsed_pageInfo.reason };
        }
        return { success: true, value: { filter: parsed_filter.value, items: parsed_items.value, pageInfo: parsed_pageInfo.value } };
      })(value["miab"]);
    })();
    if (!parsed_miab.success) {
      return { success: false, reason: parsed_miab.reason };
    }
    if (!hasProp(value, "summary")) {
      return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summary'.` };
    }
    const parsed_summary = ((): ParserResult<{
      filter: FormFilter[];
      items: ContentMetadata_SUMMARY[];
      pageInfo: PageInfo;
      sorting: FormSorting;
    }> => {
      return ((
        value: unknown,
      ): ParserResult<{
        filter: FormFilter[];
        items: ContentMetadata_SUMMARY[];
        pageInfo: PageInfo;
        sorting: FormSorting;
      }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary]: '${value}' expected to not be null.` };
        }
        if (!hasProp(value, "filter")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/filter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'filter'.` };
        }
        const parsed_filter = ((): ParserResult<FormFilter[]> => {
          return ((value: unknown): ParserResult<FormFilter[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/filter]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<FormFilter> => {
              return ((
                value: unknown,
              ): ParserResult<{
                activeValues: string[];
                identifier: FormFilterName;
                label: string;
                name: string;
                options: FormFilterOption[];
                priority: FormFilterPriority;
                type: FormFilterType;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/FormFilter]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "activeValues")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activeValues'.` };
                }
                const parsed_activeValues = ((): ParserResult<string[]> => {
                  return ((value: unknown): ParserResult<string[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilter/activeValues]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/activeValues]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["activeValues"]);
                })();
                if (!parsed_activeValues.success) {
                  return { success: false, reason: parsed_activeValues.reason };
                }
                if (!hasProp(value, "identifier")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/identifier]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'identifier'.` };
                }
                const parsed_identifier = ((): ParserResult<FormFilterName> => {
                  return ((value: unknown): ParserResult<FormFilterName> => {
                    return ((value: unknown): ParserResult<"CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "CHANNEL":
                          return { success: true, value: "CHANNEL" };
                        case "SOURCE":
                          return { success: true, value: "SOURCE" };
                        case "QUALITY":
                          return { success: true, value: "QUALITY" };
                        case "RATING":
                          return { success: true, value: "RATING" };
                        case "AUDIO":
                          return { success: true, value: "AUDIO" };
                        case "LANGUAGE":
                          return { success: true, value: "LANGUAGE" };
                        case "PUBLICATION_DATE":
                          return { success: true, value: "PUBLICATION_DATE" };
                        case "MIAB":
                          return { success: true, value: "MIAB" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be enum, one of 'CHANNEL, SOURCE, QUALITY, RATING, AUDIO, LANGUAGE, PUBLICATION_DATE, MIAB'.` };
                      }
                    })(value);
                  })(value["identifier"]);
                })();
                if (!parsed_identifier.success) {
                  return { success: false, reason: parsed_identifier.reason };
                }
                if (!hasProp(value, "label")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                }
                const parsed_label = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/label]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["label"]);
                })();
                if (!parsed_label.success) {
                  return { success: false, reason: parsed_label.reason };
                }
                if (!hasProp(value, "name")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                }
                const parsed_name = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/FormFilter/name]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["name"]);
                })();
                if (!parsed_name.success) {
                  return { success: false, reason: parsed_name.reason };
                }
                if (!hasProp(value, "options")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'options'.` };
                }
                const parsed_options = ((): ParserResult<FormFilterOption[]> => {
                  return ((value: unknown): ParserResult<FormFilterOption[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/FormFilter/options]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<FormFilterOption> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        label: string;
                        shortLabel: string | null;
                        value: string;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "label")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                        }
                        const parsed_label = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["label"]);
                        })();
                        if (!parsed_label.success) {
                          return { success: false, reason: parsed_label.reason };
                        }
                        if (!hasProp(value, "shortLabel")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shortLabel'.` };
                        }
                        const parsed_shortLabel = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["shortLabel"]);
                        })();
                        if (!parsed_shortLabel.success) {
                          return { success: false, reason: parsed_shortLabel.reason };
                        }
                        if (!hasProp(value, "value")) {
                          return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                        }
                        const parsed_value = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["value"]);
                        })();
                        if (!parsed_value.success) {
                          return { success: false, reason: parsed_value.reason };
                        }
                        return { success: true, value: { label: parsed_label.value, shortLabel: parsed_shortLabel.value, value: parsed_value.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/FormFilter/options]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["options"]);
                })();
                if (!parsed_options.success) {
                  return { success: false, reason: parsed_options.reason };
                }
                if (!hasProp(value, "priority")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/priority]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'priority'.` };
                }
                const parsed_priority = ((): ParserResult<FormFilterPriority> => {
                  return ((value: unknown): ParserResult<FormFilterPriority> => {
                    return ((value: unknown): ParserResult<"PRIMARY" | "SECONDARY"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "PRIMARY":
                          return { success: true, value: "PRIMARY" };
                        case "SECONDARY":
                          return { success: true, value: "SECONDARY" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be enum, one of 'PRIMARY, SECONDARY'.` };
                      }
                    })(value);
                  })(value["priority"]);
                })();
                if (!parsed_priority.success) {
                  return { success: false, reason: parsed_priority.reason };
                }
                if (!hasProp(value, "type")) {
                  return { success: false, reason: `[#/components/schemas/FormFilter/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
                }
                const parsed_type = ((): ParserResult<FormFilterType> => {
                  return ((value: unknown): ParserResult<FormFilterType> => {
                    return ((value: unknown): ParserResult<"MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "MULTICHECKBOX":
                          return { success: true, value: "MULTICHECKBOX" };
                        case "CHECKBOX":
                          return { success: true, value: "CHECKBOX" };
                        case "MULTISELECT":
                          return { success: true, value: "MULTISELECT" };
                        case "RANGE":
                          return { success: true, value: "RANGE" };
                        case "RANGE_MIN":
                          return { success: true, value: "RANGE_MIN" };
                        default:
                          return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be enum, one of 'MULTICHECKBOX, CHECKBOX, MULTISELECT, RANGE, RANGE_MIN'.` };
                      }
                    })(value);
                  })(value["type"]);
                })();
                if (!parsed_type.success) {
                  return { success: false, reason: parsed_type.reason };
                }
                return {
                  success: true,
                  value: {
                    activeValues: parsed_activeValues.value,
                    identifier: parsed_identifier.value,
                    label: parsed_label.value,
                    name: parsed_name.value,
                    options: parsed_options.value,
                    priority: parsed_priority.value,
                    type: parsed_type.value,
                  },
                };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/summary/filter]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["filter"]);
        })();
        if (!parsed_filter.success) {
          return { success: false, reason: parsed_filter.reason };
        }
        if (!hasProp(value, "items")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
        }
        const parsed_items = ((): ParserResult<ContentMetadata_SUMMARY[]> => {
          return ((value: unknown): ParserResult<ContentMetadata_SUMMARY[]> => {
            if (!isArray(value)) {
              return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/items]: '${value}' expected to be an array.` };
            }
            const parsed = value.map((value: unknown): ParserResult<ContentMetadata_SUMMARY> => {
              return ((
                value: unknown,
              ): ParserResult<{
                activatedAt: DateTime<true> | null;
                activationTime: DateTime<true> | null;
                active: boolean;
                audioActivatedAt: DateTime<true> | null;
                audioActive: boolean;
                audioDuration: number;
                authorInfo: string | null;
                authors: AuthorListView[];
                backgroundColor: string | null;
                bestseller: boolean;
                businessClassic: boolean;
                canonicalName: string;
                common: ContentMetadataCommon;
                contentId: ContentId_SUMMARY;
                contentItemId: bigint;
                contentItemType: ContentItemType;
                contentType: "SUMMARY";
                countriesExcluded: Country[];
                countriesIncluded: Country[];
                coverModifiedAt: DateTime<true> | null;
                coverUri: string;
                dataId: number;
                descriptionHtml: string | null;
                documentType: SummaryDocumentType;
                duration: number;
                imageBorder: boolean;
                language: Language;
                miabId: bigint | null;
                modifiedAt: DateTime<true> | null;
                originalTitle: string | null;
                previewAvailable: boolean;
                publicationDate: string | null;
                publisherInfo: string | null;
                publisherName: string | null;
                rating: number | null;
                sourceType: SummarySourceType;
                subtitle: string | null;
                summaryPages: number;
                summaryWords: number;
                tags: Tag[];
                teaser: string | null;
                title: string | null;
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "activatedAt")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
                }
                const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["activatedAt"]);
                })();
                if (!parsed_activatedAt.success) {
                  return { success: false, reason: parsed_activatedAt.reason };
                }
                if (!hasProp(value, "activationTime")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activationTime'.` };
                }
                const parsed_activationTime = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["activationTime"]);
                })();
                if (!parsed_activationTime.success) {
                  return { success: false, reason: parsed_activationTime.reason };
                }
                if (!hasProp(value, "active")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
                }
                const parsed_active = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/active]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["active"]);
                })();
                if (!parsed_active.success) {
                  return { success: false, reason: parsed_active.reason };
                }
                if (!hasProp(value, "audioActivatedAt")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActivatedAt'.` };
                }
                const parsed_audioActivatedAt = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["audioActivatedAt"]);
                })();
                if (!parsed_audioActivatedAt.success) {
                  return { success: false, reason: parsed_audioActivatedAt.reason };
                }
                if (!hasProp(value, "audioActive")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActive'.` };
                }
                const parsed_audioActive = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActive]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["audioActive"]);
                })();
                if (!parsed_audioActive.success) {
                  return { success: false, reason: parsed_audioActive.reason };
                }
                if (!hasProp(value, "audioDuration")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioDuration]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioDuration'.` };
                }
                const parsed_audioDuration = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioDuration]: '${value}' expected to be of type number.` };
                  })(value["audioDuration"]);
                })();
                if (!parsed_audioDuration.success) {
                  return { success: false, reason: parsed_audioDuration.reason };
                }
                if (!hasProp(value, "authorInfo")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/authorInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorInfo'.` };
                }
                const parsed_authorInfo = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/authorInfo]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["authorInfo"]);
                })();
                if (!parsed_authorInfo.success) {
                  return { success: false, reason: parsed_authorInfo.reason };
                }
                if (!hasProp(value, "authors")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/authors]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authors'.` };
                }
                const parsed_authors = ((): ParserResult<AuthorListView[]> => {
                  return ((value: unknown): ParserResult<AuthorListView[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/authors]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<AuthorListView> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        authorId: number;
                        firstName: string | null;
                        gender: Gender | null;
                        lastName: string | null;
                        middleName: string | null;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/AuthorListView]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "authorId")) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView/authorId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorId'.` };
                        }
                        const parsed_authorId = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            return { success: false, reason: `[#/components/schemas/AuthorListView/authorId]: '${value}' expected to be of type number.` };
                          })(value["authorId"]);
                        })();
                        if (!parsed_authorId.success) {
                          return { success: false, reason: parsed_authorId.reason };
                        }
                        if (!hasProp(value, "firstName")) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
                        }
                        const parsed_firstName = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AuthorListView/firstName]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["firstName"]);
                        })();
                        if (!parsed_firstName.success) {
                          return { success: false, reason: parsed_firstName.reason };
                        }
                        if (!hasProp(value, "gender")) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView/gender]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'gender'.` };
                        }
                        const parsed_gender = ((): ParserResult<Gender | null> => {
                          return ((value: unknown): ParserResult<Gender | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            return ((value: unknown): ParserResult<"FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM"> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be of type string.` };
                              }
                              switch (value) {
                                case "FEMALE":
                                  return { success: true, value: "FEMALE" };
                                case "MALE":
                                  return { success: true, value: "MALE" };
                                case "UNKNOWN":
                                  return { success: true, value: "UNKNOWN" };
                                case "CUSTOM":
                                  return { success: true, value: "CUSTOM" };
                                default:
                                  return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be enum, one of 'FEMALE, MALE, UNKNOWN, CUSTOM'.` };
                              }
                            })(value);
                          })(value["gender"]);
                        })();
                        if (!parsed_gender.success) {
                          return { success: false, reason: parsed_gender.reason };
                        }
                        if (!hasProp(value, "lastName")) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
                        }
                        const parsed_lastName = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AuthorListView/lastName]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["lastName"]);
                        })();
                        if (!parsed_lastName.success) {
                          return { success: false, reason: parsed_lastName.reason };
                        }
                        if (!hasProp(value, "middleName")) {
                          return { success: false, reason: `[#/components/schemas/AuthorListView/middleName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'middleName'.` };
                        }
                        const parsed_middleName = ((): ParserResult<string | null> => {
                          return ((value: unknown): ParserResult<string | null> => {
                            if (value === null) {
                              return { success: true, value: null };
                            }
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AuthorListView/middleName]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["middleName"]);
                        })();
                        if (!parsed_middleName.success) {
                          return { success: false, reason: parsed_middleName.reason };
                        }
                        return { success: true, value: { authorId: parsed_authorId.value, firstName: parsed_firstName.value, gender: parsed_gender.value, lastName: parsed_lastName.value, middleName: parsed_middleName.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/SummaryMetadata/authors]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["authors"]);
                })();
                if (!parsed_authors.success) {
                  return { success: false, reason: parsed_authors.reason };
                }
                if (!hasProp(value, "backgroundColor")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/backgroundColor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'backgroundColor'.` };
                }
                const parsed_backgroundColor = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/backgroundColor]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["backgroundColor"]);
                })();
                if (!parsed_backgroundColor.success) {
                  return { success: false, reason: parsed_backgroundColor.reason };
                }
                if (!hasProp(value, "bestseller")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/bestseller]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bestseller'.` };
                }
                const parsed_bestseller = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/bestseller]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["bestseller"]);
                })();
                if (!parsed_bestseller.success) {
                  return { success: false, reason: parsed_bestseller.reason };
                }
                if (!hasProp(value, "businessClassic")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/businessClassic]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'businessClassic'.` };
                }
                const parsed_businessClassic = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/businessClassic]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["businessClassic"]);
                })();
                if (!parsed_businessClassic.success) {
                  return { success: false, reason: parsed_businessClassic.reason };
                }
                if (!hasProp(value, "canonicalName")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/canonicalName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'canonicalName'.` };
                }
                const parsed_canonicalName = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/canonicalName]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["canonicalName"]);
                })();
                if (!parsed_canonicalName.success) {
                  return { success: false, reason: parsed_canonicalName.reason };
                }
                if (!hasProp(value, "common")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/common]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'common'.` };
                }
                const parsed_common = ((): ParserResult<ContentMetadataCommon> => {
                  return ((value: unknown): ParserResult<ContentMetadataCommon> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      activatedAt: DateTime<true> | null;
                      audioActive: boolean;
                      coverUri: string;
                      description: string | null;
                      inactive: boolean;
                      language: Language;
                      leadIn: string | null;
                      link: string | null;
                      title: string;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "activatedAt")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
                      }
                      const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
                        return ((value: unknown): ParserResult<DateTime<true> | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "number") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be of type number.` };
                          }
                          const parsed = DateTime.fromMillis(value);
                          if (!parsed.isValid) {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/activatedAt]: '${value}' expected to be valid DateTime.` };
                          }
                          return { success: true, value: parsed };
                        })(value["activatedAt"]);
                      })();
                      if (!parsed_activatedAt.success) {
                        return { success: false, reason: parsed_activatedAt.reason };
                      }
                      if (!hasProp(value, "audioActive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActive'.` };
                      }
                      const parsed_audioActive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/audioActive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["audioActive"]);
                      })();
                      if (!parsed_audioActive.success) {
                        return { success: false, reason: parsed_audioActive.reason };
                      }
                      if (!hasProp(value, "coverUri")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                      }
                      const parsed_coverUri = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/coverUri]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["coverUri"]);
                      })();
                      if (!parsed_coverUri.success) {
                        return { success: false, reason: parsed_coverUri.reason };
                      }
                      if (!hasProp(value, "description")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
                      }
                      const parsed_description = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/description]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["description"]);
                      })();
                      if (!parsed_description.success) {
                        return { success: false, reason: parsed_description.reason };
                      }
                      if (!hasProp(value, "inactive")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'inactive'.` };
                      }
                      const parsed_inactive = ((): ParserResult<boolean> => {
                        return ((value: unknown): ParserResult<boolean> => {
                          if (typeof value !== "boolean") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/inactive]: '${value}' expected to be of type boolean.` };
                          }
                          return { success: true, value: value };
                        })(value["inactive"]);
                      })();
                      if (!parsed_inactive.success) {
                        return { success: false, reason: parsed_inactive.reason };
                      }
                      if (!hasProp(value, "language")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                      }
                      const parsed_language = ((): ParserResult<Language> => {
                        return ((value: unknown): ParserResult<Language> => {
                          return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "en":
                                return { success: true, value: "en" };
                              case "de":
                                return { success: true, value: "de" };
                              case "es":
                                return { success: true, value: "es" };
                              case "ru":
                                return { success: true, value: "ru" };
                              case "zh":
                                return { success: true, value: "zh" };
                              case "pt":
                                return { success: true, value: "pt" };
                              case "fr":
                                return { success: true, value: "fr" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                            }
                          })(value);
                        })(value["language"]);
                      })();
                      if (!parsed_language.success) {
                        return { success: false, reason: parsed_language.reason };
                      }
                      if (!hasProp(value, "leadIn")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'leadIn'.` };
                      }
                      const parsed_leadIn = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/leadIn]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["leadIn"]);
                      })();
                      if (!parsed_leadIn.success) {
                        return { success: false, reason: parsed_leadIn.reason };
                      }
                      if (!hasProp(value, "link")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'link'.` };
                      }
                      const parsed_link = ((): ParserResult<string | null> => {
                        return ((value: unknown): ParserResult<string | null> => {
                          if (value === null) {
                            return { success: true, value: null };
                          }
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/link]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["link"]);
                      })();
                      if (!parsed_link.success) {
                        return { success: false, reason: parsed_link.reason };
                      }
                      if (!hasProp(value, "title")) {
                        return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                      }
                      const parsed_title = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/ContentMetadataCommon/title]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["title"]);
                      })();
                      if (!parsed_title.success) {
                        return { success: false, reason: parsed_title.reason };
                      }
                      return {
                        success: true,
                        value: {
                          activatedAt: parsed_activatedAt.value,
                          audioActive: parsed_audioActive.value,
                          coverUri: parsed_coverUri.value,
                          description: parsed_description.value,
                          inactive: parsed_inactive.value,
                          language: parsed_language.value,
                          leadIn: parsed_leadIn.value,
                          link: parsed_link.value,
                          title: parsed_title.value,
                        },
                      };
                    })(value);
                  })(value["common"]);
                })();
                if (!parsed_common.success) {
                  return { success: false, reason: parsed_common.reason };
                }
                if (!hasProp(value, "contentId")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
                }
                const parsed_contentId = ((): ParserResult<ContentId_SUMMARY> => {
                  return ((value: unknown): ParserResult<ContentId_SUMMARY> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      contentType: "SUMMARY";
                      id: bigint;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/SummaryId]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/SummaryId]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "contentType")) {
                        return { success: false, reason: `[#/components/schemas/SummaryId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                      }
                      const parsed_contentType = ((): ParserResult<"SUMMARY"> => {
                        return ((value: unknown): ParserResult<"SUMMARY"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/SummaryId/contentType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "SUMMARY":
                              return { success: true, value: "SUMMARY" };
                            default:
                              return { success: false, reason: `[#/components/schemas/SummaryId/contentType]: '${value}' expected to be enum, one of 'SUMMARY'.` };
                          }
                        })(value["contentType"]);
                      })();
                      if (!parsed_contentType.success) {
                        return { success: false, reason: parsed_contentType.reason };
                      }
                      if (!hasProp(value, "id")) {
                        return { success: false, reason: `[#/components/schemas/SummaryId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                      }
                      const parsed_id = ((): ParserResult<bigint> => {
                        return ((value: unknown): ParserResult<bigint> => {
                          if (typeof value === "number") {
                            return { success: true, value: BigInt(value) };
                          }
                          if (typeof value === "bigint") {
                            return { success: true, value: value };
                          }
                          return { success: false, reason: `[#/components/schemas/SummaryId/id]: '${value}' expected to be of type bigint or number.` };
                        })(value["id"]);
                      })();
                      if (!parsed_id.success) {
                        return { success: false, reason: parsed_id.reason };
                      }
                      return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
                    })(value);
                  })(value["contentId"]);
                })();
                if (!parsed_contentId.success) {
                  return { success: false, reason: parsed_contentId.reason };
                }
                if (!hasProp(value, "contentItemId")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemId'.` };
                }
                const parsed_contentItemId = ((): ParserResult<bigint> => {
                  return ((value: unknown): ParserResult<bigint> => {
                    if (typeof value === "number") {
                      return { success: true, value: BigInt(value) };
                    }
                    if (typeof value === "bigint") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemId]: '${value}' expected to be of type bigint or number.` };
                  })(value["contentItemId"]);
                })();
                if (!parsed_contentItemId.success) {
                  return { success: false, reason: parsed_contentItemId.reason };
                }
                if (!hasProp(value, "contentItemType")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemType'.` };
                }
                const parsed_contentItemType = ((): ParserResult<ContentItemType> => {
                  return ((value: unknown): ParserResult<ContentItemType> => {
                    return ((value: unknown): ParserResult<"UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "LGXP" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "UNKNOWN":
                          return { success: true, value: "UNKNOWN" };
                        case "SUMMARY":
                          return { success: true, value: "SUMMARY" };
                        case "CATEGORY":
                          return { success: true, value: "CATEGORY" };
                        case "CHANNEL":
                          return { success: true, value: "CHANNEL" };
                        case "LGXP":
                          return { success: true, value: "LGXP" };
                        case "ACTIONABLE":
                          return { success: true, value: "ACTIONABLE" };
                        case "MYLIST":
                          return { success: true, value: "MYLIST" };
                        case "CUSTOMPAGE":
                          return { success: true, value: "CUSTOMPAGE" };
                        case "MIAB":
                          return { success: true, value: "MIAB" };
                        case "EXPERT_VIDEO":
                          return { success: true, value: "EXPERT_VIDEO" };
                        case "CUSTOMER_STORY":
                          return { success: true, value: "CUSTOMER_STORY" };
                        default:
                          return {
                            success: false,
                            reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be enum, one of 'UNKNOWN, SUMMARY, CATEGORY, CHANNEL, LGXP, ACTIONABLE, MYLIST, CUSTOMPAGE, MIAB, EXPERT_VIDEO, CUSTOMER_STORY'.`,
                          };
                      }
                    })(value);
                  })(value["contentItemType"]);
                })();
                if (!parsed_contentItemType.success) {
                  return { success: false, reason: parsed_contentItemType.reason };
                }
                if (!hasProp(value, "contentType")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
                }
                const parsed_contentType = ((): ParserResult<"SUMMARY"> => {
                  return ((value: unknown): ParserResult<"SUMMARY"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "SUMMARY":
                        return { success: true, value: "SUMMARY" };
                      default:
                        return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${value}' expected to be enum, one of 'SUMMARY'.` };
                    }
                  })(value["contentType"]);
                })();
                if (!parsed_contentType.success) {
                  return { success: false, reason: parsed_contentType.reason };
                }
                if (!hasProp(value, "countriesExcluded")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countriesExcluded'.` };
                }
                const parsed_countriesExcluded = ((): ParserResult<Country[]> => {
                  return ((value: unknown): ParserResult<Country[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<Country> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        countryCode: string;
                        currency: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY";
                        names: {
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        };
                        phonePrefix: string;
                        region: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA";
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/Country]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/Country]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "countryCode")) {
                          return { success: false, reason: `[#/components/schemas/Country/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                        }
                        const parsed_countryCode = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/countryCode]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["countryCode"]);
                        })();
                        if (!parsed_countryCode.success) {
                          return { success: false, reason: parsed_countryCode.reason };
                        }
                        if (!hasProp(value, "currency")) {
                          return { success: false, reason: `[#/components/schemas/Country/currency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'currency'.` };
                        }
                        const parsed_currency = ((): ParserResult<"CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"> => {
                          return ((value: unknown): ParserResult<"CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/currency]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "CHF":
                                return { success: true, value: "CHF" };
                              case "CNY":
                                return { success: true, value: "CNY" };
                              case "USD":
                                return { success: true, value: "USD" };
                              case "EUR":
                                return { success: true, value: "EUR" };
                              case "GBP":
                                return { success: true, value: "GBP" };
                              case "INR":
                                return { success: true, value: "INR" };
                              case "JPY":
                                return { success: true, value: "JPY" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Country/currency]: '${value}' expected to be enum, one of 'CHF, CNY, USD, EUR, GBP, INR, JPY'.` };
                            }
                          })(value["currency"]);
                        })();
                        if (!parsed_currency.success) {
                          return { success: false, reason: parsed_currency.reason };
                        }
                        if (!hasProp(value, "names")) {
                          return { success: false, reason: `[#/components/schemas/Country/names]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'names'.` };
                        }
                        const parsed_names = ((): ParserResult<{
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        }> => {
                          return ((
                            value: unknown,
                          ): ParserResult<{
                            de: string;
                            en: string;
                            es: string;
                            fr: string;
                            pt: string;
                            ru: string;
                            zh: string;
                          }> => {
                            if (typeof value !== "object") {
                              return { success: false, reason: `[#/components/schemas/Country/names]: '${value}' expected to be of type 'object'.` };
                            }
                            if (value === null) {
                              return { success: false, reason: `[#/components/schemas/Country/names]: '${value}' expected to not be null.` };
                            }
                            if (!hasProp(value, "de")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/de]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'de'.` };
                            }
                            const parsed_de = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/de]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["de"]);
                            })();
                            if (!parsed_de.success) {
                              return { success: false, reason: parsed_de.reason };
                            }
                            if (!hasProp(value, "en")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/en]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'en'.` };
                            }
                            const parsed_en = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/en]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["en"]);
                            })();
                            if (!parsed_en.success) {
                              return { success: false, reason: parsed_en.reason };
                            }
                            if (!hasProp(value, "es")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/es]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'es'.` };
                            }
                            const parsed_es = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/es]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["es"]);
                            })();
                            if (!parsed_es.success) {
                              return { success: false, reason: parsed_es.reason };
                            }
                            if (!hasProp(value, "fr")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/fr]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fr'.` };
                            }
                            const parsed_fr = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/fr]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["fr"]);
                            })();
                            if (!parsed_fr.success) {
                              return { success: false, reason: parsed_fr.reason };
                            }
                            if (!hasProp(value, "pt")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/pt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pt'.` };
                            }
                            const parsed_pt = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/pt]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["pt"]);
                            })();
                            if (!parsed_pt.success) {
                              return { success: false, reason: parsed_pt.reason };
                            }
                            if (!hasProp(value, "ru")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/ru]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ru'.` };
                            }
                            const parsed_ru = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/ru]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["ru"]);
                            })();
                            if (!parsed_ru.success) {
                              return { success: false, reason: parsed_ru.reason };
                            }
                            if (!hasProp(value, "zh")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/zh]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zh'.` };
                            }
                            const parsed_zh = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/zh]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["zh"]);
                            })();
                            if (!parsed_zh.success) {
                              return { success: false, reason: parsed_zh.reason };
                            }
                            return { success: true, value: { de: parsed_de.value, en: parsed_en.value, es: parsed_es.value, fr: parsed_fr.value, pt: parsed_pt.value, ru: parsed_ru.value, zh: parsed_zh.value } };
                          })(value["names"]);
                        })();
                        if (!parsed_names.success) {
                          return { success: false, reason: parsed_names.reason };
                        }
                        if (!hasProp(value, "phonePrefix")) {
                          return { success: false, reason: `[#/components/schemas/Country/phonePrefix]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'phonePrefix'.` };
                        }
                        const parsed_phonePrefix = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/phonePrefix]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["phonePrefix"]);
                        })();
                        if (!parsed_phonePrefix.success) {
                          return { success: false, reason: parsed_phonePrefix.reason };
                        }
                        if (!hasProp(value, "region")) {
                          return { success: false, reason: `[#/components/schemas/Country/region]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'region'.` };
                        }
                        const parsed_region = ((): ParserResult<"SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"> => {
                          return ((value: unknown): ParserResult<"SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/region]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "SOUTHAMERICA":
                                return { success: true, value: "SOUTHAMERICA" };
                              case "EUROPE":
                                return { success: true, value: "EUROPE" };
                              case "OCEANIA":
                                return { success: true, value: "OCEANIA" };
                              case "NORTHAMERICA":
                                return { success: true, value: "NORTHAMERICA" };
                              case "AFRICA":
                                return { success: true, value: "AFRICA" };
                              case "ANTARCTICA":
                                return { success: true, value: "ANTARCTICA" };
                              case "ASIA":
                                return { success: true, value: "ASIA" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Country/region]: '${value}' expected to be enum, one of 'SOUTHAMERICA, EUROPE, OCEANIA, NORTHAMERICA, AFRICA, ANTARCTICA, ASIA'.` };
                            }
                          })(value["region"]);
                        })();
                        if (!parsed_region.success) {
                          return { success: false, reason: parsed_region.reason };
                        }
                        return { success: true, value: { countryCode: parsed_countryCode.value, currency: parsed_currency.value, names: parsed_names.value, phonePrefix: parsed_phonePrefix.value, region: parsed_region.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["countriesExcluded"]);
                })();
                if (!parsed_countriesExcluded.success) {
                  return { success: false, reason: parsed_countriesExcluded.reason };
                }
                if (!hasProp(value, "countriesIncluded")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countriesIncluded'.` };
                }
                const parsed_countriesIncluded = ((): ParserResult<Country[]> => {
                  return ((value: unknown): ParserResult<Country[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<Country> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        countryCode: string;
                        currency: "CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY";
                        names: {
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        };
                        phonePrefix: string;
                        region: "SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA";
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/Country]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/Country]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "countryCode")) {
                          return { success: false, reason: `[#/components/schemas/Country/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                        }
                        const parsed_countryCode = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/countryCode]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["countryCode"]);
                        })();
                        if (!parsed_countryCode.success) {
                          return { success: false, reason: parsed_countryCode.reason };
                        }
                        if (!hasProp(value, "currency")) {
                          return { success: false, reason: `[#/components/schemas/Country/currency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'currency'.` };
                        }
                        const parsed_currency = ((): ParserResult<"CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"> => {
                          return ((value: unknown): ParserResult<"CHF" | "CNY" | "USD" | "EUR" | "GBP" | "INR" | "JPY"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/currency]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "CHF":
                                return { success: true, value: "CHF" };
                              case "CNY":
                                return { success: true, value: "CNY" };
                              case "USD":
                                return { success: true, value: "USD" };
                              case "EUR":
                                return { success: true, value: "EUR" };
                              case "GBP":
                                return { success: true, value: "GBP" };
                              case "INR":
                                return { success: true, value: "INR" };
                              case "JPY":
                                return { success: true, value: "JPY" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Country/currency]: '${value}' expected to be enum, one of 'CHF, CNY, USD, EUR, GBP, INR, JPY'.` };
                            }
                          })(value["currency"]);
                        })();
                        if (!parsed_currency.success) {
                          return { success: false, reason: parsed_currency.reason };
                        }
                        if (!hasProp(value, "names")) {
                          return { success: false, reason: `[#/components/schemas/Country/names]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'names'.` };
                        }
                        const parsed_names = ((): ParserResult<{
                          de: string;
                          en: string;
                          es: string;
                          fr: string;
                          pt: string;
                          ru: string;
                          zh: string;
                        }> => {
                          return ((
                            value: unknown,
                          ): ParserResult<{
                            de: string;
                            en: string;
                            es: string;
                            fr: string;
                            pt: string;
                            ru: string;
                            zh: string;
                          }> => {
                            if (typeof value !== "object") {
                              return { success: false, reason: `[#/components/schemas/Country/names]: '${value}' expected to be of type 'object'.` };
                            }
                            if (value === null) {
                              return { success: false, reason: `[#/components/schemas/Country/names]: '${value}' expected to not be null.` };
                            }
                            if (!hasProp(value, "de")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/de]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'de'.` };
                            }
                            const parsed_de = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/de]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["de"]);
                            })();
                            if (!parsed_de.success) {
                              return { success: false, reason: parsed_de.reason };
                            }
                            if (!hasProp(value, "en")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/en]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'en'.` };
                            }
                            const parsed_en = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/en]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["en"]);
                            })();
                            if (!parsed_en.success) {
                              return { success: false, reason: parsed_en.reason };
                            }
                            if (!hasProp(value, "es")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/es]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'es'.` };
                            }
                            const parsed_es = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/es]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["es"]);
                            })();
                            if (!parsed_es.success) {
                              return { success: false, reason: parsed_es.reason };
                            }
                            if (!hasProp(value, "fr")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/fr]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fr'.` };
                            }
                            const parsed_fr = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/fr]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["fr"]);
                            })();
                            if (!parsed_fr.success) {
                              return { success: false, reason: parsed_fr.reason };
                            }
                            if (!hasProp(value, "pt")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/pt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pt'.` };
                            }
                            const parsed_pt = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/pt]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["pt"]);
                            })();
                            if (!parsed_pt.success) {
                              return { success: false, reason: parsed_pt.reason };
                            }
                            if (!hasProp(value, "ru")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/ru]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ru'.` };
                            }
                            const parsed_ru = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/ru]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["ru"]);
                            })();
                            if (!parsed_ru.success) {
                              return { success: false, reason: parsed_ru.reason };
                            }
                            if (!hasProp(value, "zh")) {
                              return { success: false, reason: `[#/components/schemas/Country/names/zh]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zh'.` };
                            }
                            const parsed_zh = ((): ParserResult<string> => {
                              return ((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/Country/names/zh]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              })(value["zh"]);
                            })();
                            if (!parsed_zh.success) {
                              return { success: false, reason: parsed_zh.reason };
                            }
                            return { success: true, value: { de: parsed_de.value, en: parsed_en.value, es: parsed_es.value, fr: parsed_fr.value, pt: parsed_pt.value, ru: parsed_ru.value, zh: parsed_zh.value } };
                          })(value["names"]);
                        })();
                        if (!parsed_names.success) {
                          return { success: false, reason: parsed_names.reason };
                        }
                        if (!hasProp(value, "phonePrefix")) {
                          return { success: false, reason: `[#/components/schemas/Country/phonePrefix]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'phonePrefix'.` };
                        }
                        const parsed_phonePrefix = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/phonePrefix]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["phonePrefix"]);
                        })();
                        if (!parsed_phonePrefix.success) {
                          return { success: false, reason: parsed_phonePrefix.reason };
                        }
                        if (!hasProp(value, "region")) {
                          return { success: false, reason: `[#/components/schemas/Country/region]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'region'.` };
                        }
                        const parsed_region = ((): ParserResult<"SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"> => {
                          return ((value: unknown): ParserResult<"SOUTHAMERICA" | "EUROPE" | "OCEANIA" | "NORTHAMERICA" | "AFRICA" | "ANTARCTICA" | "ASIA"> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/Country/region]: '${value}' expected to be of type string.` };
                            }
                            switch (value) {
                              case "SOUTHAMERICA":
                                return { success: true, value: "SOUTHAMERICA" };
                              case "EUROPE":
                                return { success: true, value: "EUROPE" };
                              case "OCEANIA":
                                return { success: true, value: "OCEANIA" };
                              case "NORTHAMERICA":
                                return { success: true, value: "NORTHAMERICA" };
                              case "AFRICA":
                                return { success: true, value: "AFRICA" };
                              case "ANTARCTICA":
                                return { success: true, value: "ANTARCTICA" };
                              case "ASIA":
                                return { success: true, value: "ASIA" };
                              default:
                                return { success: false, reason: `[#/components/schemas/Country/region]: '${value}' expected to be enum, one of 'SOUTHAMERICA, EUROPE, OCEANIA, NORTHAMERICA, AFRICA, ANTARCTICA, ASIA'.` };
                            }
                          })(value["region"]);
                        })();
                        if (!parsed_region.success) {
                          return { success: false, reason: parsed_region.reason };
                        }
                        return { success: true, value: { countryCode: parsed_countryCode.value, currency: parsed_currency.value, names: parsed_names.value, phonePrefix: parsed_phonePrefix.value, region: parsed_region.value } };
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["countriesIncluded"]);
                })();
                if (!parsed_countriesIncluded.success) {
                  return { success: false, reason: parsed_countriesIncluded.reason };
                }
                if (!hasProp(value, "coverModifiedAt")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverModifiedAt'.` };
                }
                const parsed_coverModifiedAt = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["coverModifiedAt"]);
                })();
                if (!parsed_coverModifiedAt.success) {
                  return { success: false, reason: parsed_coverModifiedAt.reason };
                }
                if (!hasProp(value, "coverUri")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                }
                const parsed_coverUri = ((): ParserResult<string> => {
                  return ((value: unknown): ParserResult<string> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverUri]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["coverUri"]);
                })();
                if (!parsed_coverUri.success) {
                  return { success: false, reason: parsed_coverUri.reason };
                }
                if (!hasProp(value, "dataId")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
                }
                const parsed_dataId = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/dataId]: '${value}' expected to be of type number.` };
                  })(value["dataId"]);
                })();
                if (!parsed_dataId.success) {
                  return { success: false, reason: parsed_dataId.reason };
                }
                if (!hasProp(value, "descriptionHtml")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/descriptionHtml]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'descriptionHtml'.` };
                }
                const parsed_descriptionHtml = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/descriptionHtml]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["descriptionHtml"]);
                })();
                if (!parsed_descriptionHtml.success) {
                  return { success: false, reason: parsed_descriptionHtml.reason };
                }
                if (!hasProp(value, "documentType")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/documentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'documentType'.` };
                }
                const parsed_documentType = ((): ParserResult<SummaryDocumentType> => {
                  return ((value: unknown): ParserResult<SummaryDocumentType> => {
                    return ((value: unknown): ParserResult<"ABSTRACT" | "REVIEW"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SummaryDocumentType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "ABSTRACT":
                          return { success: true, value: "ABSTRACT" };
                        case "REVIEW":
                          return { success: true, value: "REVIEW" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SummaryDocumentType]: '${value}' expected to be enum, one of 'ABSTRACT, REVIEW'.` };
                      }
                    })(value);
                  })(value["documentType"]);
                })();
                if (!parsed_documentType.success) {
                  return { success: false, reason: parsed_documentType.reason };
                }
                if (!hasProp(value, "duration")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/duration]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'duration'.` };
                }
                const parsed_duration = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/duration]: '${value}' expected to be of type number.` };
                  })(value["duration"]);
                })();
                if (!parsed_duration.success) {
                  return { success: false, reason: parsed_duration.reason };
                }
                if (!hasProp(value, "imageBorder")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/imageBorder]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'imageBorder'.` };
                }
                const parsed_imageBorder = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/imageBorder]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["imageBorder"]);
                })();
                if (!parsed_imageBorder.success) {
                  return { success: false, reason: parsed_imageBorder.reason };
                }
                if (!hasProp(value, "language")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                }
                const parsed_language = ((): ParserResult<Language> => {
                  return ((value: unknown): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "en":
                          return { success: true, value: "en" };
                        case "de":
                          return { success: true, value: "de" };
                        case "es":
                          return { success: true, value: "es" };
                        case "ru":
                          return { success: true, value: "ru" };
                        case "zh":
                          return { success: true, value: "zh" };
                        case "pt":
                          return { success: true, value: "pt" };
                        case "fr":
                          return { success: true, value: "fr" };
                        default:
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                      }
                    })(value);
                  })(value["language"]);
                })();
                if (!parsed_language.success) {
                  return { success: false, reason: parsed_language.reason };
                }
                if (!hasProp(value, "miabId")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/miabId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'miabId'.` };
                }
                const parsed_miabId = ((): ParserResult<bigint | null> => {
                  return ((value: unknown): ParserResult<bigint | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value === "number") {
                      return { success: true, value: BigInt(value) };
                    }
                    if (typeof value === "bigint") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/miabId]: '${value}' expected to be of type bigint or number.` };
                  })(value["miabId"]);
                })();
                if (!parsed_miabId.success) {
                  return { success: false, reason: parsed_miabId.reason };
                }
                if (!hasProp(value, "modifiedAt")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
                }
                const parsed_modifiedAt = ((): ParserResult<DateTime<true> | null> => {
                  return ((value: unknown): ParserResult<DateTime<true> | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "number") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${value}' expected to be of type number.` };
                    }
                    const parsed = DateTime.fromMillis(value);
                    if (!parsed.isValid) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${value}' expected to be valid DateTime.` };
                    }
                    return { success: true, value: parsed };
                  })(value["modifiedAt"]);
                })();
                if (!parsed_modifiedAt.success) {
                  return { success: false, reason: parsed_modifiedAt.reason };
                }
                if (!hasProp(value, "originalTitle")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/originalTitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'originalTitle'.` };
                }
                const parsed_originalTitle = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/originalTitle]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["originalTitle"]);
                })();
                if (!parsed_originalTitle.success) {
                  return { success: false, reason: parsed_originalTitle.reason };
                }
                if (!hasProp(value, "previewAvailable")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/previewAvailable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'previewAvailable'.` };
                }
                const parsed_previewAvailable = ((): ParserResult<boolean> => {
                  return ((value: unknown): ParserResult<boolean> => {
                    if (typeof value !== "boolean") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/previewAvailable]: '${value}' expected to be of type boolean.` };
                    }
                    return { success: true, value: value };
                  })(value["previewAvailable"]);
                })();
                if (!parsed_previewAvailable.success) {
                  return { success: false, reason: parsed_previewAvailable.reason };
                }
                if (!hasProp(value, "publicationDate")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/publicationDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publicationDate'.` };
                }
                const parsed_publicationDate = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publicationDate]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["publicationDate"]);
                })();
                if (!parsed_publicationDate.success) {
                  return { success: false, reason: parsed_publicationDate.reason };
                }
                if (!hasProp(value, "publisherInfo")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisherInfo'.` };
                }
                const parsed_publisherInfo = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherInfo]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["publisherInfo"]);
                })();
                if (!parsed_publisherInfo.success) {
                  return { success: false, reason: parsed_publisherInfo.reason };
                }
                if (!hasProp(value, "publisherName")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisherName'.` };
                }
                const parsed_publisherName = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherName]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["publisherName"]);
                })();
                if (!parsed_publisherName.success) {
                  return { success: false, reason: parsed_publisherName.reason };
                }
                if (!hasProp(value, "rating")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
                }
                const parsed_rating = ((): ParserResult<number | null> => {
                  return ((value: unknown): ParserResult<number | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/rating]: '${value}' expected to be of type number.` };
                  })(value["rating"]);
                })();
                if (!parsed_rating.success) {
                  return { success: false, reason: parsed_rating.reason };
                }
                if (!hasProp(value, "sourceType")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/sourceType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceType'.` };
                }
                const parsed_sourceType = ((): ParserResult<SummarySourceType> => {
                  return ((value: unknown): ParserResult<SummarySourceType> => {
                    return ((value: unknown): ParserResult<"BOOK" | "VIDEO" | "ARTICLE" | "CHAPTER" | "REPORT" | "PODCAST"> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SummarySourceType]: '${value}' expected to be of type string.` };
                      }
                      switch (value) {
                        case "BOOK":
                          return { success: true, value: "BOOK" };
                        case "VIDEO":
                          return { success: true, value: "VIDEO" };
                        case "ARTICLE":
                          return { success: true, value: "ARTICLE" };
                        case "CHAPTER":
                          return { success: true, value: "CHAPTER" };
                        case "REPORT":
                          return { success: true, value: "REPORT" };
                        case "PODCAST":
                          return { success: true, value: "PODCAST" };
                        default:
                          return { success: false, reason: `[#/components/schemas/SummarySourceType]: '${value}' expected to be enum, one of 'BOOK, VIDEO, ARTICLE, CHAPTER, REPORT, PODCAST'.` };
                      }
                    })(value);
                  })(value["sourceType"]);
                })();
                if (!parsed_sourceType.success) {
                  return { success: false, reason: parsed_sourceType.reason };
                }
                if (!hasProp(value, "subtitle")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/subtitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subtitle'.` };
                }
                const parsed_subtitle = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/subtitle]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["subtitle"]);
                })();
                if (!parsed_subtitle.success) {
                  return { success: false, reason: parsed_subtitle.reason };
                }
                if (!hasProp(value, "summaryPages")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryPages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summaryPages'.` };
                }
                const parsed_summaryPages = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryPages]: '${value}' expected to be of type number.` };
                  })(value["summaryPages"]);
                })();
                if (!parsed_summaryPages.success) {
                  return { success: false, reason: parsed_summaryPages.reason };
                }
                if (!hasProp(value, "summaryWords")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryWords]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summaryWords'.` };
                }
                const parsed_summaryWords = ((): ParserResult<number> => {
                  return ((value: unknown): ParserResult<number> => {
                    if (typeof value === "number") {
                      return { success: true, value: value };
                    }
                    return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryWords]: '${value}' expected to be of type number.` };
                  })(value["summaryWords"]);
                })();
                if (!parsed_summaryWords.success) {
                  return { success: false, reason: parsed_summaryWords.reason };
                }
                if (!hasProp(value, "tags")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/tags]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tags'.` };
                }
                const parsed_tags = ((): ParserResult<Tag[]> => {
                  return ((value: unknown): ParserResult<Tag[]> => {
                    if (!isArray(value)) {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/tags]: '${value}' expected to be an array.` };
                    }
                    const parsed = value.map((value: unknown): ParserResult<Tag> => {
                      return ((
                        value: unknown,
                      ): ParserResult<
                        | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                        | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                        | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                        | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                        | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                        | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                        | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                        | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                        | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                      > => {
                        return ((
                          value: unknown,
                        ): ParserResult<
                          | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                          | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                          | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                          | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                          | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                          | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                          | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                          | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                          | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                        > => {
                          if (value == null) {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${value}' expected to be non-null.` };
                          }
                          if (typeof value != "object") {
                            return { success: false, reason: `[#/components/schemas/Tag]: ${value} expected to be of type 'object'.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          if (typeof value["discriminator"] != "string") {
                            return { success: false, reason: `[#/components/schemas/Tag]: '${value["discriminator"]}' expected to be of type 'string'.` };
                          }
                          const discriminator = value["discriminator"];
                          switch (discriminator) {
                            case "dynamicString": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicString;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicString> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicString> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicString;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicString> => {
                                        return ((value: unknown): ParserResult<KindDynamicString> => {
                                          return ((value: unknown): ParserResult<"dynamicString"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicString":
                                                return { success: true, value: "dynamicString" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be enum, one of 'dynamicString'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicString" as const, ...parsedVariant.value } };
                            }
                            case "dynamicBoolean": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicBoolean;
                                value: boolean;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicBoolean> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicBoolean> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicBoolean;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicBoolean> => {
                                        return ((value: unknown): ParserResult<KindDynamicBoolean> => {
                                          return ((value: unknown): ParserResult<"dynamicBoolean"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicBoolean":
                                                return { success: true, value: "dynamicBoolean" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be enum, one of 'dynamicBoolean'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicBoolean" as const, ...parsedVariant.value } };
                            }
                            case "dynamicNumber": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicNumber;
                                value: number;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicNumber> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicNumber> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicNumber;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicNumber> => {
                                        return ((value: unknown): ParserResult<KindDynamicNumber> => {
                                          return ((value: unknown): ParserResult<"dynamicNumber"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicNumber":
                                                return { success: true, value: "dynamicNumber" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be enum, one of 'dynamicNumber'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${value}' expected to be of type number.` };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicNumber" as const, ...parsedVariant.value } };
                            }
                            case "dynamicVoid": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindDynamicVoid;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindDynamicVoid> => {
                                  return ((value: unknown): ParserResult<TagKindDynamicVoid> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindDynamicVoid;
                                      id: bigint;
                                      kind: string;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindDynamicVoid> => {
                                        return ((value: unknown): ParserResult<KindDynamicVoid> => {
                                          return ((value: unknown): ParserResult<"dynamicVoid"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "dynamicVoid":
                                                return { success: true, value: "dynamicVoid" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be enum, one of 'dynamicVoid'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<string> => {
                                        return ((value: unknown): ParserResult<string> => {
                                          if (typeof value !== "string") {
                                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${value}' expected to be of type string.` };
                                          }
                                          return { success: true, value: value };
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "dynamicVoid" as const, ...parsedVariant.value } };
                            }
                            case "channel": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindChannel;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindChannel> => {
                                  return ((value: unknown): ParserResult<TagKindChannel> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindChannel;
                                      id: bigint;
                                      kind: KindChannel;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindChannel> => {
                                        return ((value: unknown): ParserResult<KindChannel> => {
                                          return ((value: unknown): ParserResult<"channel"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "channel":
                                                return { success: true, value: "channel" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindChannel/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindChannel> => {
                                        return ((value: unknown): ParserResult<KindChannel> => {
                                          return ((value: unknown): ParserResult<"channel"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "channel":
                                                return { success: true, value: "channel" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "channel" as const, ...parsedVariant.value } };
                            }
                            case "primary-skill": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindPrimarySkill;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindPrimarySkill> => {
                                  return ((value: unknown): ParserResult<TagKindPrimarySkill> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindPrimarySkill;
                                      id: bigint;
                                      kind: KindPrimarySkill;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindPrimarySkill> => {
                                        return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                          return ((value: unknown): ParserResult<"primary-skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "primary-skill":
                                                return { success: true, value: "primary-skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindPrimarySkill> => {
                                        return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                          return ((value: unknown): ParserResult<"primary-skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "primary-skill":
                                                return { success: true, value: "primary-skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "primary-skill" as const, ...parsedVariant.value } };
                            }
                            case "skill": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindSkill;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindSkill> => {
                                  return ((value: unknown): ParserResult<TagKindSkill> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindSkill;
                                      id: bigint;
                                      kind: KindSkill;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindSkill> => {
                                        return ((value: unknown): ParserResult<KindSkill> => {
                                          return ((value: unknown): ParserResult<"skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "skill":
                                                return { success: true, value: "skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindSkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindSkill> => {
                                        return ((value: unknown): ParserResult<KindSkill> => {
                                          return ((value: unknown): ParserResult<"skill"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "skill":
                                                return { success: true, value: "skill" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "skill" as const, ...parsedVariant.value } };
                            }
                            case "key-quality": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindKeyQuality;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindKeyQuality> => {
                                  return ((value: unknown): ParserResult<TagKindKeyQuality> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindKeyQuality;
                                      id: bigint;
                                      kind: KindKeyQuality;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindKeyQuality> => {
                                        return ((value: unknown): ParserResult<KindKeyQuality> => {
                                          return ((value: unknown): ParserResult<"key-quality"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "key-quality":
                                                return { success: true, value: "key-quality" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindKeyQuality> => {
                                        return ((value: unknown): ParserResult<KindKeyQuality> => {
                                          return ((value: unknown): ParserResult<"key-quality"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "key-quality":
                                                return { success: true, value: "key-quality" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "key-quality" as const, ...parsedVariant.value } };
                            }
                            case "classification": {
                              const parsedVariant = ((
                                value: unknown,
                              ): ParserResult<{
                                exclude: boolean;
                                score: number;
                                source: TagSourceType;
                                tagKind: TagKindClassification;
                                value: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "exclude")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                                }
                                const parsed_exclude = ((): ParserResult<boolean> => {
                                  return ((value: unknown): ParserResult<boolean> => {
                                    if (typeof value !== "boolean") {
                                      return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${value}' expected to be of type boolean.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["exclude"]);
                                })();
                                if (!parsed_exclude.success) {
                                  return { success: false, reason: parsed_exclude.reason };
                                }
                                if (!hasProp(value, "score")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                                }
                                const parsed_score = ((): ParserResult<number> => {
                                  return ((value: unknown): ParserResult<number> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: value };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: Number(value) };
                                    }
                                    return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${value}' expected to be of type number or bigint.` };
                                  })(value["score"]);
                                })();
                                if (!parsed_score.success) {
                                  return { success: false, reason: parsed_score.reason };
                                }
                                if (!hasProp(value, "source")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                                }
                                const parsed_source = ((): ParserResult<TagSourceType> => {
                                  return ((value: unknown): ParserResult<TagSourceType> => {
                                    return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "USER":
                                          return { success: true, value: "USER" };
                                        case "AI":
                                          return { success: true, value: "AI" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                      }
                                    })(value);
                                  })(value["source"]);
                                })();
                                if (!parsed_source.success) {
                                  return { success: false, reason: parsed_source.reason };
                                }
                                if (!hasProp(value, "tagKind")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                                }
                                const parsed_tagKind = ((): ParserResult<TagKindClassification> => {
                                  return ((value: unknown): ParserResult<TagKindClassification> => {
                                    return ((
                                      value: unknown,
                                    ): ParserResult<{
                                      discriminator: KindClassification;
                                      id: bigint;
                                      kind: KindClassification;
                                    }> => {
                                      if (typeof value !== "object") {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to be of type 'object'.` };
                                      }
                                      if (value === null) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to not be null.` };
                                      }
                                      if (!hasProp(value, "discriminator")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                      }
                                      const parsed_discriminator = ((): ParserResult<KindClassification> => {
                                        return ((value: unknown): ParserResult<KindClassification> => {
                                          return ((value: unknown): ParserResult<"classification"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "classification":
                                                return { success: true, value: "classification" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                            }
                                          })(value);
                                        })(value["discriminator"]);
                                      })();
                                      if (!parsed_discriminator.success) {
                                        return { success: false, reason: parsed_discriminator.reason };
                                      }
                                      if (!hasProp(value, "id")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                      }
                                      const parsed_id = ((): ParserResult<bigint> => {
                                        return ((value: unknown): ParserResult<bigint> => {
                                          if (typeof value === "number") {
                                            return { success: true, value: BigInt(value) };
                                          }
                                          if (typeof value === "bigint") {
                                            return { success: true, value: value };
                                          }
                                          return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${value}' expected to be of type bigint or number.` };
                                        })(value["id"]);
                                      })();
                                      if (!parsed_id.success) {
                                        return { success: false, reason: parsed_id.reason };
                                      }
                                      if (!hasProp(value, "kind")) {
                                        return { success: false, reason: `[#/components/schemas/TagKindClassification/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                      }
                                      const parsed_kind = ((): ParserResult<KindClassification> => {
                                        return ((value: unknown): ParserResult<KindClassification> => {
                                          return ((value: unknown): ParserResult<"classification"> => {
                                            if (typeof value !== "string") {
                                              return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                            }
                                            switch (value) {
                                              case "classification":
                                                return { success: true, value: "classification" };
                                              default:
                                                return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                            }
                                          })(value);
                                        })(value["kind"]);
                                      })();
                                      if (!parsed_kind.success) {
                                        return { success: false, reason: parsed_kind.reason };
                                      }
                                      return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                                    })(value);
                                  })(value["tagKind"]);
                                })();
                                if (!parsed_tagKind.success) {
                                  return { success: false, reason: parsed_tagKind.reason };
                                }
                                if (!hasProp(value, "value")) {
                                  return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                                }
                                const parsed_value = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["value"]);
                                })();
                                if (!parsed_value.success) {
                                  return { success: false, reason: parsed_value.reason };
                                }
                                return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                              })(value);
                              if (!parsedVariant.success) {
                                return { success: false, reason: parsedVariant.reason };
                              }
                              return { success: true, value: { discriminator: "classification" as const, ...parsedVariant.value } };
                            }
                            default:
                              return {
                                success: false,
                                reason: `[#/components/schemas/Tag]: '${discriminator}' expected to be one of 'dynamicString, dynamicBoolean, dynamicNumber, dynamicVoid, channel, primary-skill, skill, key-quality, classification'.`,
                              };
                          }
                        })(value);
                      })(value);
                    });
                    if (parsed.find((value) => !value.success) !== undefined) {
                      return {
                        success: false,
                        reason: `[#/components/schemas/SummaryMetadata/tags]: Reason(s): '${parsed
                          .filter((p) => !p.success)
                          .map((p) => p.reason)
                          .join(", ")}'.`,
                      };
                    }
                    return {
                      success: true,
                      value: parsed.map((entry) => {
                        assert(entry.success == true);
                        return entry.value;
                      }),
                    };
                  })(value["tags"]);
                })();
                if (!parsed_tags.success) {
                  return { success: false, reason: parsed_tags.reason };
                }
                if (!hasProp(value, "teaser")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/teaser]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teaser'.` };
                }
                const parsed_teaser = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/teaser]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["teaser"]);
                })();
                if (!parsed_teaser.success) {
                  return { success: false, reason: parsed_teaser.reason };
                }
                if (!hasProp(value, "title")) {
                  return { success: false, reason: `[#/components/schemas/SummaryMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                }
                const parsed_title = ((): ParserResult<string | null> => {
                  return ((value: unknown): ParserResult<string | null> => {
                    if (value === null) {
                      return { success: true, value: null };
                    }
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/SummaryMetadata/title]: '${value}' expected to be of type string.` };
                    }
                    return { success: true, value: value };
                  })(value["title"]);
                })();
                if (!parsed_title.success) {
                  return { success: false, reason: parsed_title.reason };
                }
                return {
                  success: true,
                  value: {
                    activatedAt: parsed_activatedAt.value,
                    activationTime: parsed_activationTime.value,
                    active: parsed_active.value,
                    audioActivatedAt: parsed_audioActivatedAt.value,
                    audioActive: parsed_audioActive.value,
                    audioDuration: parsed_audioDuration.value,
                    authorInfo: parsed_authorInfo.value,
                    authors: parsed_authors.value,
                    backgroundColor: parsed_backgroundColor.value,
                    bestseller: parsed_bestseller.value,
                    businessClassic: parsed_businessClassic.value,
                    canonicalName: parsed_canonicalName.value,
                    common: parsed_common.value,
                    contentId: parsed_contentId.value,
                    contentItemId: parsed_contentItemId.value,
                    contentItemType: parsed_contentItemType.value,
                    contentType: parsed_contentType.value,
                    countriesExcluded: parsed_countriesExcluded.value,
                    countriesIncluded: parsed_countriesIncluded.value,
                    coverModifiedAt: parsed_coverModifiedAt.value,
                    coverUri: parsed_coverUri.value,
                    dataId: parsed_dataId.value,
                    descriptionHtml: parsed_descriptionHtml.value,
                    documentType: parsed_documentType.value,
                    duration: parsed_duration.value,
                    imageBorder: parsed_imageBorder.value,
                    language: parsed_language.value,
                    miabId: parsed_miabId.value,
                    modifiedAt: parsed_modifiedAt.value,
                    originalTitle: parsed_originalTitle.value,
                    previewAvailable: parsed_previewAvailable.value,
                    publicationDate: parsed_publicationDate.value,
                    publisherInfo: parsed_publisherInfo.value,
                    publisherName: parsed_publisherName.value,
                    rating: parsed_rating.value,
                    sourceType: parsed_sourceType.value,
                    subtitle: parsed_subtitle.value,
                    summaryPages: parsed_summaryPages.value,
                    summaryWords: parsed_summaryWords.value,
                    tags: parsed_tags.value,
                    teaser: parsed_teaser.value,
                    title: parsed_title.value,
                  },
                };
              })(value);
            });
            if (parsed.find((value) => !value.success) !== undefined) {
              return {
                success: false,
                reason: `[#/components/schemas/ContentMetadataView/summary/items]: Reason(s): '${parsed
                  .filter((p) => !p.success)
                  .map((p) => p.reason)
                  .join(", ")}'.`,
              };
            }
            return {
              success: true,
              value: parsed.map((entry) => {
                assert(entry.success == true);
                return entry.value;
              }),
            };
          })(value["items"]);
        })();
        if (!parsed_items.success) {
          return { success: false, reason: parsed_items.reason };
        }
        if (!hasProp(value, "pageInfo")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/pageInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageInfo'.` };
        }
        const parsed_pageInfo = ((): ParserResult<PageInfo> => {
          return ((value: unknown): ParserResult<PageInfo> => {
            return ((
              value: unknown,
            ): ParserResult<{
              page: number;
              pageSize: number;
              totalCount: number;
            }> => {
              if (typeof value !== "object") {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to be of type 'object'.` };
              }
              if (value === null) {
                return { success: false, reason: `[#/components/schemas/PageInfo]: '${value}' expected to not be null.` };
              }
              if (!hasProp(value, "page")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'page'.` };
              }
              const parsed_page = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/page]: '${value}' expected to be of type number.` };
                })(value["page"]);
              })();
              if (!parsed_page.success) {
                return { success: false, reason: parsed_page.reason };
              }
              if (!hasProp(value, "pageSize")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pageSize'.` };
              }
              const parsed_pageSize = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/pageSize]: '${value}' expected to be of type number.` };
                })(value["pageSize"]);
              })();
              if (!parsed_pageSize.success) {
                return { success: false, reason: parsed_pageSize.reason };
              }
              if (!hasProp(value, "totalCount")) {
                return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'totalCount'.` };
              }
              const parsed_totalCount = ((): ParserResult<number> => {
                return ((value: unknown): ParserResult<number> => {
                  if (typeof value === "number") {
                    return { success: true, value: value };
                  }
                  return { success: false, reason: `[#/components/schemas/PageInfo/totalCount]: '${value}' expected to be of type number.` };
                })(value["totalCount"]);
              })();
              if (!parsed_totalCount.success) {
                return { success: false, reason: parsed_totalCount.reason };
              }
              return { success: true, value: { page: parsed_page.value, pageSize: parsed_pageSize.value, totalCount: parsed_totalCount.value } };
            })(value);
          })(value["pageInfo"]);
        })();
        if (!parsed_pageInfo.success) {
          return { success: false, reason: parsed_pageInfo.reason };
        }
        if (!hasProp(value, "sorting")) {
          return { success: false, reason: `[#/components/schemas/ContentMetadataView/summary/sorting]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sorting'.` };
        }
        const parsed_sorting = ((): ParserResult<FormSorting> => {
          return ((value: unknown): ParserResult<FormSorting> => {
            return ((
              value: unknown,
            ): ParserResult<{
              activeValue: string;
              options: FormSortingOption[];
            }> => {
              if (typeof value !== "object") {
                return { success: false, reason: `[#/components/schemas/FormSorting]: '${value}' expected to be of type 'object'.` };
              }
              if (value === null) {
                return { success: false, reason: `[#/components/schemas/FormSorting]: '${value}' expected to not be null.` };
              }
              if (!hasProp(value, "activeValue")) {
                return { success: false, reason: `[#/components/schemas/FormSorting/activeValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activeValue'.` };
              }
              const parsed_activeValue = ((): ParserResult<string> => {
                return ((value: unknown): ParserResult<string> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/FormSorting/activeValue]: '${value}' expected to be of type string.` };
                  }
                  return { success: true, value: value };
                })(value["activeValue"]);
              })();
              if (!parsed_activeValue.success) {
                return { success: false, reason: parsed_activeValue.reason };
              }
              if (!hasProp(value, "options")) {
                return { success: false, reason: `[#/components/schemas/FormSorting/options]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'options'.` };
              }
              const parsed_options = ((): ParserResult<FormSortingOption[]> => {
                return ((value: unknown): ParserResult<FormSortingOption[]> => {
                  if (!isArray(value)) {
                    return { success: false, reason: `[#/components/schemas/FormSorting/options]: '${value}' expected to be an array.` };
                  }
                  const parsed = value.map((value: unknown): ParserResult<FormSortingOption> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      label: string;
                      value: string;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/FormSortingOption]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/FormSortingOption]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "label")) {
                        return { success: false, reason: `[#/components/schemas/FormSortingOption/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
                      }
                      const parsed_label = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/FormSortingOption/label]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["label"]);
                      })();
                      if (!parsed_label.success) {
                        return { success: false, reason: parsed_label.reason };
                      }
                      if (!hasProp(value, "value")) {
                        return { success: false, reason: `[#/components/schemas/FormSortingOption/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                      }
                      const parsed_value = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/FormSortingOption/value]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["value"]);
                      })();
                      if (!parsed_value.success) {
                        return { success: false, reason: parsed_value.reason };
                      }
                      return { success: true, value: { label: parsed_label.value, value: parsed_value.value } };
                    })(value);
                  });
                  if (parsed.find((value) => !value.success) !== undefined) {
                    return {
                      success: false,
                      reason: `[#/components/schemas/FormSorting/options]: Reason(s): '${parsed
                        .filter((p) => !p.success)
                        .map((p) => p.reason)
                        .join(", ")}'.`,
                    };
                  }
                  return {
                    success: true,
                    value: parsed.map((entry) => {
                      assert(entry.success == true);
                      return entry.value;
                    }),
                  };
                })(value["options"]);
              })();
              if (!parsed_options.success) {
                return { success: false, reason: parsed_options.reason };
              }
              return { success: true, value: { activeValue: parsed_activeValue.value, options: parsed_options.value } };
            })(value);
          })(value["sorting"]);
        })();
        if (!parsed_sorting.success) {
          return { success: false, reason: parsed_sorting.reason };
        }
        return { success: true, value: { filter: parsed_filter.value, items: parsed_items.value, pageInfo: parsed_pageInfo.value, sorting: parsed_sorting.value } };
      })(value["summary"]);
    })();
    if (!parsed_summary.success) {
      return { success: false, reason: parsed_summary.reason };
    }
    return { success: true, value: { actionable: parsed_actionable.value, miab: parsed_miab.value, summary: parsed_summary.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
